/* tslint:disable */
/* eslint-disable */
/**
 * WebBet API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var ActiveEventStatus;
(function (ActiveEventStatus) {
    ActiveEventStatus["Open"] = "EVENT_OPEN";
    ActiveEventStatus["Trading"] = "EVENT_TRADING";
    ActiveEventStatus["Suspended"] = "EVENT_SUSPENDED";
    ActiveEventStatus["Planning"] = "EVENT_PLANNING";
    ActiveEventStatus["Ended"] = "EVENT_ENDED";
})(ActiveEventStatus || (ActiveEventStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var AppliedCouponStatus;
(function (AppliedCouponStatus) {
    AppliedCouponStatus["Created"] = "CREATED";
    AppliedCouponStatus["Applied"] = "APPLIED";
    AppliedCouponStatus["Used"] = "USED";
    AppliedCouponStatus["Expired"] = "EXPIRED";
    AppliedCouponStatus["CancellationInProcess"] = "CANCELLATION_IN_PROCESS";
    AppliedCouponStatus["Cancelled"] = "CANCELLED";
    AppliedCouponStatus["RestrictionFailed"] = "RESTRICTION_FAILED";
    AppliedCouponStatus["Unknown"] = "UNKNOWN";
})(AppliedCouponStatus || (AppliedCouponStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ApplyStatus;
(function (ApplyStatus) {
    ApplyStatus["Created"] = "CREATED";
    ApplyStatus["Applied"] = "APPLIED";
    ApplyStatus["Used"] = "USED";
    ApplyStatus["PartialUsed"] = "PARTIAL_USED";
    ApplyStatus["Expired"] = "EXPIRED";
    ApplyStatus["CancellationInProcess"] = "CANCELLATION_IN_PROCESS";
    ApplyStatus["Cancelled"] = "CANCELLED";
    ApplyStatus["RestrictionFailed"] = "RESTRICTION_FAILED";
    ApplyStatus["Unknown"] = "UNKNOWN";
})(ApplyStatus || (ApplyStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ApproveStatus;
(function (ApproveStatus) {
    ApproveStatus["New"] = "NEW";
    ApproveStatus["Positive"] = "POSITIVE";
    ApproveStatus["Negative"] = "NEGATIVE";
})(ApproveStatus || (ApproveStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BasketStatus;
(function (BasketStatus) {
    BasketStatus["Opened"] = "OPENED";
    BasketStatus["Processing"] = "PROCESSING";
    BasketStatus["Executed"] = "EXECUTED";
})(BasketStatus || (BasketStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BetCreationMethod;
(function (BetCreationMethod) {
    BetCreationMethod["Basket"] = "BASKET";
    BetCreationMethod["QuickBet"] = "QUICK_BET";
})(BetCreationMethod || (BetCreationMethod = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BetOutcomeStatus;
(function (BetOutcomeStatus) {
    BetOutcomeStatus["Na"] = "NA";
    BetOutcomeStatus["Win"] = "WIN";
    BetOutcomeStatus["Lost"] = "LOST";
    BetOutcomeStatus["Return"] = "RETURN";
    BetOutcomeStatus["WinReturn"] = "WIN_RETURN";
    BetOutcomeStatus["LostReturn"] = "LOST_RETURN";
})(BetOutcomeStatus || (BetOutcomeStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BetSaveAny;
(function (BetSaveAny) {
    BetSaveAny["Never"] = "NEVER";
    BetSaveAny["Partly"] = "PARTLY";
    BetSaveAny["Always"] = "ALWAYS";
})(BetSaveAny || (BetSaveAny = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BetStatus;
(function (BetStatus) {
    BetStatus["Current"] = "CURRENT";
    BetStatus["Computed"] = "COMPUTED";
    BetStatus["Won"] = "WON";
    BetStatus["Returned"] = "RETURNED";
    BetStatus["Lost"] = "LOST";
    BetStatus["Canceled"] = "CANCELED";
    BetStatus["Sold"] = "SOLD";
    BetStatus["Unknown"] = "UNKNOWN";
})(BetStatus || (BetStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BetType;
(function (BetType) {
    BetType["Ordinar"] = "ORDINAR";
    BetType["Express"] = "EXPRESS";
    BetType["System"] = "SYSTEM";
})(BetType || (BetType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BroadcastType;
(function (BroadcastType) {
    BroadcastType["Hls"] = "HLS";
    BroadcastType["Iframe"] = "IFRAME";
})(BroadcastType || (BroadcastType = {}));
/**
 * Type of the captcha provider
 * @export
 * @enum {string}
 */
export var CaptchaProviderType;
(function (CaptchaProviderType) {
    CaptchaProviderType["Google"] = "GOOGLE";
    CaptchaProviderType["GoogleEnterprise"] = "GOOGLE_ENTERPRISE";
    CaptchaProviderType["Huawei"] = "HUAWEI";
    CaptchaProviderType["Yandex"] = "YANDEX";
    CaptchaProviderType["Custom"] = "CUSTOM";
})(CaptchaProviderType || (CaptchaProviderType = {}));
/**
    * @export
    * @enum {string}
    */
export var ClientGroupsEnum;
(function (ClientGroupsEnum) {
    ClientGroupsEnum["Unrecognized"] = "UNRECOGNIZED";
    ClientGroupsEnum["Client"] = "CLIENT";
    ClientGroupsEnum["Operator"] = "OPERATOR";
})(ClientGroupsEnum || (ClientGroupsEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var ClientStatusEnum;
(function (ClientStatusEnum) {
    ClientStatusEnum["Unrecognized"] = "UNRECOGNIZED";
    ClientStatusEnum["New"] = "NEW";
    ClientStatusEnum["Active"] = "ACTIVE";
    ClientStatusEnum["Blocked"] = "BLOCKED";
    ClientStatusEnum["ForcedDeleted"] = "FORCED_DELETED";
})(ClientStatusEnum || (ClientStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var ClientVerificationStatusEnum;
(function (ClientVerificationStatusEnum) {
    ClientVerificationStatusEnum["NotVerified"] = "NOT_VERIFIED";
    ClientVerificationStatusEnum["PartlyVerified"] = "PARTLY_VERIFIED";
    ClientVerificationStatusEnum["Verified"] = "VERIFIED";
})(ClientVerificationStatusEnum || (ClientVerificationStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CompletionStatus;
(function (CompletionStatus) {
    CompletionStatus["Ended"] = "ENDED";
    CompletionStatus["Live"] = "LIVE";
})(CompletionStatus || (CompletionStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CouponPayoutType;
(function (CouponPayoutType) {
    CouponPayoutType["CouponPayout"] = "COUPON_PAYOUT";
    CouponPayoutType["WinAmount"] = "WIN_AMOUNT";
    CouponPayoutType["Unknown"] = "UNKNOWN";
})(CouponPayoutType || (CouponPayoutType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CreateBetStatus;
(function (CreateBetStatus) {
    CreateBetStatus["Successful"] = "SUCCESSFUL";
    CreateBetStatus["SystemError"] = "SYSTEM_ERROR";
    CreateBetStatus["ChangedCoefficient"] = "CHANGED_COEFFICIENT";
    CreateBetStatus["EventUndefined"] = "EVENT_UNDEFINED";
    CreateBetStatus["Suspended"] = "SUSPENDED";
    CreateBetStatus["AmountLowerThanAllowed"] = "AMOUNT_LOWER_THAN_ALLOWED";
    CreateBetStatus["ChangedCoefMultiplier"] = "CHANGED_COEF_MULTIPLIER";
})(CreateBetStatus || (CreateBetStatus = {}));
/**
 * The cursor reset policy for the consumer  - EARLIEST: The consumer will read from the start of the buffer - LATEST: The consumer will read from the end of the buffer - STRICT: The consumer will read from the last read position represented by the given cursor
 * @export
 * @enum {string}
 */
export var CursorResetPolicy;
(function (CursorResetPolicy) {
    CursorResetPolicy["Earliest"] = "EARLIEST";
    CursorResetPolicy["Latest"] = "LATEST";
    CursorResetPolicy["Strict"] = "STRICT";
})(CursorResetPolicy || (CursorResetPolicy = {}));
/**
 * A unique identifier for the error
 * @export
 * @enum {string}
 */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["VerificationPauseNotCompleted"] = "VERIFICATION_PAUSE_NOT_COMPLETED";
    ErrorCode["MaxVerificationAttemptCountExceeded"] = "MAX_VERIFICATION_ATTEMPT_COUNT_EXCEEDED";
    ErrorCode["NotFound"] = "NOT_FOUND";
    ErrorCode["ClientBetsBlock"] = "CLIENT_BETS_BLOCK";
    ErrorCode["ClientInvalidAccount"] = "CLIENT_INVALID_ACCOUNT";
    ErrorCode["IncorrectValidationCode"] = "INCORRECT_VALIDATION_CODE";
    ErrorCode["IncorrectOldPassword"] = "INCORRECT_OLD_PASSWORD";
    ErrorCode["VerificationError"] = "VERIFICATION_ERROR";
    ErrorCode["MailAlreadyUse"] = "MAIL_ALREADY_USE";
    ErrorCode["RestrictedFieldUpdate"] = "RESTRICTED_FIELD_UPDATE";
    ErrorCode["ReverificationIsProhibited"] = "REVERIFICATION_IS_PROHIBITED";
    ErrorCode["InvalidRequest"] = "INVALID_REQUEST";
    ErrorCode["IncorrectCashoutAmount"] = "INCORRECT_CASHOUT_AMOUNT";
    ErrorCode["SmsSendingError"] = "SMS_SENDING_ERROR";
    ErrorCode["ControlQuestionNotFound"] = "CONTROL_QUESTION_NOT_FOUND";
    ErrorCode["BetsAmountLessThanAllowed"] = "BETS_AMOUNT_LESS_THAN_ALLOWED";
    ErrorCode["SaleBetsNotAllowed"] = "SALE_BETS_NOT_ALLOWED";
    ErrorCode["CashoutNotAllowed"] = "CASHOUT_NOT_ALLOWED";
    ErrorCode["CashoutNotAvailable"] = "CASHOUT_NOT_AVAILABLE";
    ErrorCode["TooManyRequests"] = "TOO_MANY_REQUESTS";
    ErrorCode["ClientError"] = "CLIENT_ERROR";
    ErrorCode["ServerError"] = "SERVER_ERROR";
    ErrorCode["BetSuccessful"] = "BET_SUCCESSFUL";
    ErrorCode["BetSystemError"] = "BET_SYSTEM_ERROR";
    ErrorCode["BetChangedCoefficient"] = "BET_CHANGED_COEFFICIENT";
    ErrorCode["BetEventUndefined"] = "BET_EVENT_UNDEFINED";
    ErrorCode["BetSuspended"] = "BET_SUSPENDED";
    ErrorCode["BetAmountLowerThanAllowed"] = "BET_AMOUNT_LOWER_THAN_ALLOWED";
    ErrorCode["BetChangedCoefMultiplier"] = "BET_CHANGED_COEF_MULTIPLIER";
    ErrorCode["BetsOnlyOrdinarRule"] = "BETS_ONLY_ORDINAR_RULE";
    ErrorCode["BetsEventsMatched"] = "BETS_EVENTS_MATCHED";
    ErrorCode["BetsOutcomesInequality"] = "BETS_OUTCOMES_INEQUALITY";
    ErrorCode["BetsPayMaxExceeded"] = "BETS_PAY_MAX_EXCEEDED";
    ErrorCode["BetsSystemExpressLoweringBound"] = "BETS_SYSTEM_EXPRESS_LOWERING_BOUND";
    ErrorCode["BetsInsufficientBalance"] = "BETS_INSUFFICIENT_BALANCE";
    ErrorCode["BetsInsufficientBonusBalance"] = "BETS_INSUFFICIENT_BONUS_BALANCE";
    ErrorCode["BetsHaveDependentEvents"] = "BETS_HAVE_DEPENDENT_EVENTS";
    ErrorCode["BasketInProcessing"] = "BASKET_IN_PROCESSING";
    ErrorCode["CouponNotAvailable"] = "COUPON_NOT_AVAILABLE";
    ErrorCode["CouponNotFound"] = "COUPON_NOT_FOUND";
    ErrorCode["CouponInsufficientBetsQuantity"] = "COUPON_INSUFFICIENT_BETS_QUANTITY";
    ErrorCode["CouponWrongMinOrdinarCoef"] = "COUPON_WRONG_MIN_ORDINAR_COEF";
    ErrorCode["CouponWrongMaxOrdinarCoef"] = "COUPON_WRONG_MAX_ORDINAR_COEF";
    ErrorCode["CouponWrongMinExpressCoef"] = "COUPON_WRONG_MIN_EXPRESS_COEF";
    ErrorCode["CouponWrongMaxExpressCoef"] = "COUPON_WRONG_MAX_EXPRESS_COEF";
    ErrorCode["CouponWrongMinCoefInsideExpress"] = "COUPON_WRONG_MIN_COEF_INSIDE_EXPRESS";
    ErrorCode["CouponWrongMaxCoefInsideExpress"] = "COUPON_WRONG_MAX_COEF_INSIDE_EXPRESS";
    ErrorCode["InvalidCursor"] = "INVALID_CURSOR";
    ErrorCode["CursorOutOfRange"] = "CURSOR_OUT_OF_RANGE";
    ErrorCode["ClientWithdrawalsBlock"] = "CLIENT_WITHDRAWALS_BLOCK";
    ErrorCode["InvalidTaxProviderResponse"] = "INVALID_TAX_PROVIDER_RESPONSE";
    ErrorCode["WithdrawSplitForbidden"] = "WITHDRAW_SPLIT_FORBIDDEN";
    ErrorCode["AnotherWithdrawStillActive"] = "ANOTHER_WITHDRAW_STILL_ACTIVE";
    ErrorCode["ClientPaymentsBlock"] = "CLIENT_PAYMENTS_BLOCK";
    ErrorCode["PaymentsMethodRateLimitReached"] = "PAYMENTS_METHOD_RATE_LIMIT_REACHED";
    ErrorCode["PaymentsMethodRateLimitReachedForClient"] = "PAYMENTS_METHOD_RATE_LIMIT_REACHED_FOR_CLIENT";
    ErrorCode["PaymentsProviderInternal"] = "PAYMENTS_PROVIDER_INTERNAL";
    ErrorCode["PaymentsProviderInvalidArgument"] = "PAYMENTS_PROVIDER_INVALID_ARGUMENT";
    ErrorCode["PaymentsProviderFailedPrecondition"] = "PAYMENTS_PROVIDER_FAILED_PRECONDITION";
    ErrorCode["PaymentsProviderForbiddenForClient"] = "PAYMENTS_PROVIDER_FORBIDDEN_FOR_CLIENT";
    ErrorCode["PaymentsProviderTemporalOutage"] = "PAYMENTS_PROVIDER_TEMPORAL_OUTAGE";
    ErrorCode["PaymentsProviderExternalSystem"] = "PAYMENTS_PROVIDER_EXTERNAL_SYSTEM";
    ErrorCode["PaymentsProviderInvalidAccountKey"] = "PAYMENTS_PROVIDER_INVALID_ACCOUNT_KEY";
    ErrorCode["PaymentsProviderCallsThrottled"] = "PAYMENTS_PROVIDER_CALLS_THROTTLED";
    ErrorCode["CaptchaVerificationRequired"] = "CAPTCHA_VERIFICATION_REQUIRED";
    ErrorCode["CaptchaVerificationUnsupportedProvider"] = "CAPTCHA_VERIFICATION_UNSUPPORTED_PROVIDER";
    ErrorCode["CaptchaVerificationTokenExpired"] = "CAPTCHA_VERIFICATION_TOKEN_EXPIRED";
    ErrorCode["CaptchaVerificationInvalidParams"] = "CAPTCHA_VERIFICATION_INVALID_PARAMS";
    ErrorCode["CaptchaVerificationFailed"] = "CAPTCHA_VERIFICATION_FAILED";
    ErrorCode["Unknown"] = "UNKNOWN";
})(ErrorCode || (ErrorCode = {}));
/**
 * Type of third-party integration provider
 * @export
 * @enum {string}
 */
export var EventIntegrationType;
(function (EventIntegrationType) {
    EventIntegrationType["HeadToHead"] = "HEAD_TO_HEAD";
    EventIntegrationType["Grid"] = "GRID";
})(EventIntegrationType || (EventIntegrationType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventLiveliness;
(function (EventLiveliness) {
    EventLiveliness["Line"] = "LINE";
    EventLiveliness["Live"] = "LIVE";
    EventLiveliness["All"] = "ALL";
})(EventLiveliness || (EventLiveliness = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventProbabilitiesCategoryStatus;
(function (EventProbabilitiesCategoryStatus) {
    EventProbabilitiesCategoryStatus["Unknown"] = "CATEGORY_UNKNOWN";
    EventProbabilitiesCategoryStatus["Trading"] = "CATEGORY_TRADING";
    EventProbabilitiesCategoryStatus["Suspended"] = "CATEGORY_SUSPENDED";
})(EventProbabilitiesCategoryStatus || (EventProbabilitiesCategoryStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventProbabilityTradingStatus;
(function (EventProbabilityTradingStatus) {
    EventProbabilityTradingStatus["Trading"] = "PROBABILITY_TRADING";
    EventProbabilityTradingStatus["Suspended"] = "PROBABILITY_SUSPENDED";
    EventProbabilityTradingStatus["Settled"] = "PROBABILITY_SETTLED";
})(EventProbabilityTradingStatus || (EventProbabilityTradingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventSourceType;
(function (EventSourceType) {
    EventSourceType["Unknown"] = "EVENT_SOURCE_UNKNOWN";
    EventSourceType["Betradar"] = "EVENT_SOURCE_BETRADAR";
    EventSourceType["Betgenius"] = "EVENT_SOURCE_BETGENIUS";
    EventSourceType["Betconstruct"] = "EVENT_SOURCE_BETCONSTRUCT";
    EventSourceType["Lsports"] = "EVENT_SOURCE_LSPORTS";
    EventSourceType["Betbazar"] = "EVENT_SOURCE_BETBAZAR";
    EventSourceType["Model"] = "EVENT_SOURCE_MODEL";
    EventSourceType["Manual"] = "EVENT_SOURCE_MANUAL";
    EventSourceType["ForcedModel"] = "EVENT_SOURCE_FORCED_MODEL";
    EventSourceType["Olimp"] = "EVENT_SOURCE_OLIMP";
    EventSourceType["Beter"] = "EVENT_SOURCE_BETER";
    EventSourceType["Baseline"] = "EVENT_SOURCE_BASELINE";
    EventSourceType["Openbet"] = "EVENT_SOURCE_OPENBET";
    EventSourceType["Fonbet"] = "EVENT_SOURCE_FONBET";
    EventSourceType["Sportlevel"] = "EVENT_SOURCE_SPORTLEVEL";
    EventSourceType["Maxsports"] = "EVENT_SOURCE_MAXSPORTS";
    EventSourceType["AutoCalculation"] = "EVENT_SOURCE_AUTO_CALCULATION";
})(EventSourceType || (EventSourceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventStatus;
(function (EventStatus) {
    EventStatus["Open"] = "EVENT_OPEN";
    EventStatus["Trading"] = "EVENT_TRADING";
    EventStatus["Suspended"] = "EVENT_SUSPENDED";
    EventStatus["Planning"] = "EVENT_PLANNING";
    EventStatus["Closed"] = "EVENT_CLOSED";
    EventStatus["Ended"] = "EVENT_ENDED";
    EventStatus["Cancelled"] = "EVENT_CANCELLED";
    EventStatus["Postponed"] = "EVENT_POSTPONED";
    EventStatus["Interrupted"] = "EVENT_INTERRUPTED";
    EventStatus["Retired"] = "EVENT_RETIRED";
})(EventStatus || (EventStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ExclusionEntityType;
(function (ExclusionEntityType) {
    ExclusionEntityType["Sport"] = "SPORT";
    ExclusionEntityType["SportGroup"] = "SPORT_GROUP";
    ExclusionEntityType["Tournament"] = "TOURNAMENT";
    ExclusionEntityType["SportEvent"] = "SPORT_EVENT";
})(ExclusionEntityType || (ExclusionEntityType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var HotProbabilityMarketType;
(function (HotProbabilityMarketType) {
    HotProbabilityMarketType["Unknown"] = "UNKNOWN";
    HotProbabilityMarketType["MatchWinnerX3"] = "MATCH_WINNER_X3";
    HotProbabilityMarketType["DoubleChance"] = "DOUBLE_CHANCE";
    HotProbabilityMarketType["Handicap"] = "HANDICAP";
    HotProbabilityMarketType["Total"] = "TOTAL";
    HotProbabilityMarketType["MatchWinnerX2"] = "MATCH_WINNER_X2";
    HotProbabilityMarketType["MatchWinnerX2WithOt"] = "MATCH_WINNER_X2_WITH_OT";
    HotProbabilityMarketType["HandicapWithOt"] = "HANDICAP_WITH_OT";
    HotProbabilityMarketType["TotalWithOt"] = "TOTAL_WITH_OT";
})(HotProbabilityMarketType || (HotProbabilityMarketType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LayoutTheme;
(function (LayoutTheme) {
    LayoutTheme["Unknown"] = "UNKNOWN";
    LayoutTheme["Dark"] = "DARK";
    LayoutTheme["Light"] = "LIGHT";
})(LayoutTheme || (LayoutTheme = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LogoEntityType;
(function (LogoEntityType) {
    LogoEntityType["Tournament"] = "TOURNAMENT";
    LogoEntityType["Competitor"] = "COMPETITOR";
    LogoEntityType["Player"] = "PLAYER";
})(LogoEntityType || (LogoEntityType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LogoExtension;
(function (LogoExtension) {
    LogoExtension["Svg"] = "SVG";
    LogoExtension["Png"] = "PNG";
    LogoExtension["Jpg"] = "JPG";
})(LogoExtension || (LogoExtension = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MarketLink;
(function (MarketLink) {
    MarketLink["Unknown"] = "UNKNOWN";
    MarketLink["Any"] = "ANY";
    MarketLink["TotalUnder"] = "TOTAL_UNDER";
    MarketLink["TotalOver"] = "TOTAL_OVER";
    MarketLink["HandicapHome"] = "HANDICAP_HOME";
    MarketLink["HandicapAway"] = "HANDICAP_AWAY";
    MarketLink["Yes"] = "YES";
    MarketLink["No"] = "NO";
})(MarketLink || (MarketLink = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MarketType;
(function (MarketType) {
    MarketType["Unknown"] = "UNKNOWN";
    MarketType["All"] = "ALL";
    MarketType["Total"] = "TOTAL";
    MarketType["Handicap"] = "HANDICAP";
    MarketType["YesNo"] = "YES_NO";
})(MarketType || (MarketType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var MethodParameterType;
(function (MethodParameterType) {
    MethodParameterType["Unknown"] = "METHOD_PARAMETER_UNKNOWN";
    MethodParameterType["String"] = "METHOD_PARAMETER_STRING";
    MethodParameterType["Int32"] = "METHOD_PARAMETER_INT32";
    MethodParameterType["Int64"] = "METHOD_PARAMETER_INT64";
    MethodParameterType["Bool"] = "METHOD_PARAMETER_BOOL";
    MethodParameterType["Double"] = "METHOD_PARAMETER_DOUBLE";
    MethodParameterType["AccountKey"] = "METHOD_PARAMETER_ACCOUNT_KEY";
    MethodParameterType["IpAddress"] = "METHOD_PARAMETER_IP_ADDRESS";
    MethodParameterType["CardNumber"] = "METHOD_PARAMETER_CARD_NUMBER";
    MethodParameterType["AccountNumber"] = "METHOD_PARAMETER_ACCOUNT_NUMBER";
    MethodParameterType["Iban"] = "METHOD_PARAMETER_IBAN";
    MethodParameterType["PhoneNumber"] = "METHOD_PARAMETER_PHONE_NUMBER";
    MethodParameterType["Email"] = "METHOD_PARAMETER_EMAIL";
})(MethodParameterType || (MethodParameterType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OptionalParameterType;
(function (OptionalParameterType) {
    OptionalParameterType["StringParameter"] = "STRING_PARAMETER";
    OptionalParameterType["BoolParameter"] = "BOOL_PARAMETER";
    OptionalParameterType["Int32Parameter"] = "INT32_PARAMETER";
    OptionalParameterType["Uint64Parameter"] = "UINT64_PARAMETER";
    OptionalParameterType["Uint32Parameter"] = "UINT32_PARAMETER";
    OptionalParameterType["Int64Parameter"] = "INT64_PARAMETER";
    OptionalParameterType["DoubleParameter"] = "DOUBLE_PARAMETER";
    OptionalParameterType["ImageParameter"] = "IMAGE_PARAMETER";
})(OptionalParameterType || (OptionalParameterType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order || (Order = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "ASC";
    OrderDirection["Desc"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaginationKeyDirection;
(function (PaginationKeyDirection) {
    PaginationKeyDirection["Forward"] = "FORWARD";
    PaginationKeyDirection["Backward"] = "BACKWARD";
})(PaginationKeyDirection || (PaginationKeyDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ParameterOperator;
(function (ParameterOperator) {
    ParameterOperator["Unknown"] = "OPERATOR_UNKNOWN";
    ParameterOperator["Equal"] = "OPERATOR_EQUAL";
    ParameterOperator["MoreThanOrEqual"] = "OPERATOR_MORE_THAN_OR_EQUAL";
    ParameterOperator["LessThanOrEqual"] = "OPERATOR_LESS_THAN_OR_EQUAL";
})(ParameterOperator || (ParameterOperator = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ParameterType;
(function (ParameterType) {
    ParameterType["Unknown"] = "PARAMETER_UNKNOWN";
    ParameterType["Value"] = "PARAMETER_VALUE";
    ParameterType["PlayerId"] = "PARAMETER_PLAYER_ID";
    ParameterType["GoalNumber"] = "PARAMETER_GOAL_NUMBER";
    ParameterType["PointNumber"] = "PARAMETER_POINT_NUMBER";
    ParameterType["GoalsRange"] = "PARAMETER_GOALS_RANGE";
    ParameterType["Bestof"] = "PARAMETER_BESTOF";
    ParameterType["MaxGoals"] = "PARAMETER_MAX_GOALS";
    ParameterType["SetNumber"] = "PARAMETER_SET_NUMBER";
    ParameterType["GameNumber"] = "PARAMETER_GAME_NUMBER";
    ParameterType["InningNumber"] = "PARAMETER_INNING_NUMBER";
    ParameterType["MapNumber"] = "PARAMETER_MAP_NUMBER";
    ParameterType["ExactGoals"] = "PARAMETER_EXACT_GOALS";
    ParameterType["TimeRange"] = "PARAMETER_TIME_RANGE";
    ParameterType["RoundNumber"] = "PARAMETER_ROUND_NUMBER";
    ParameterType["HomeScore"] = "PARAMETER_HOME_SCORE";
    ParameterType["AwayScore"] = "PARAMETER_AWAY_SCORE";
    ParameterType["HalfNumber"] = "PARAMETER_HALF_NUMBER";
    ParameterType["ExtraHalfNumber"] = "PARAMETER_EXTRA_HALF_NUMBER";
    ParameterType["QuarterNumber"] = "PARAMETER_QUARTER_NUMBER";
    ParameterType["PeriodNumber"] = "PARAMETER_PERIOD_NUMBER";
    ParameterType["FrameNumber"] = "PARAMETER_FRAME_NUMBER";
    ParameterType["From"] = "PARAMETER_FROM";
    ParameterType["To"] = "PARAMETER_TO";
    ParameterType["WinningMargin"] = "PARAMETER_WINNING_MARGIN";
    ParameterType["CompetitorId"] = "PARAMETER_COMPETITOR_ID";
    ParameterType["KillNumber"] = "PARAMETER_KILL_NUMBER";
    ParameterType["LegNumber"] = "PARAMETER_LEG_NUMBER";
    ParameterType["OverNumber"] = "PARAMETER_OVER_NUMBER";
    ParameterType["PointRange"] = "PARAMETER_POINT_RANGE";
    ParameterType["WicketNumber"] = "PARAMETER_WICKET_NUMBER";
    ParameterType["DeliveryNumber"] = "PARAMETER_DELIVERY_NUMBER";
    ParameterType["Number"] = "PARAMETER_NUMBER";
    ParameterType["Range"] = "PARAMETER_RANGE";
    ParameterType["Exact"] = "PARAMETER_EXACT";
    ParameterType["HalfHomeScore"] = "PARAMETER_HALF_HOME_SCORE";
    ParameterType["HalfAwayScore"] = "PARAMETER_HALF_AWAY_SCORE";
})(ParameterType || (ParameterType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["New"] = "NEW";
    PaymentStatus["InProgress"] = "IN_PROGRESS";
    PaymentStatus["Success"] = "SUCCESS";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Cancel"] = "CANCEL";
})(PaymentStatus || (PaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PeriodStatType;
(function (PeriodStatType) {
    PeriodStatType["MainScore"] = "MAIN_SCORE";
    PeriodStatType["Corners"] = "CORNERS";
    PeriodStatType["YellowCards"] = "YELLOW_CARDS";
    PeriodStatType["ShotsOnTarget"] = "SHOTS_ON_TARGET";
    PeriodStatType["Offsides"] = "OFFSIDES";
    PeriodStatType["Fouls"] = "FOULS";
    PeriodStatType["ThrowIns"] = "THROW_INS";
    PeriodStatType["Woodworks"] = "WOODWORKS";
    PeriodStatType["GoalKicks"] = "GOAL_KICKS";
})(PeriodStatType || (PeriodStatType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProviderType;
(function (ProviderType) {
    ProviderType["Unknown"] = "UNKNOWN";
    ProviderType["Betradar"] = "BETRADAR";
    ProviderType["Perform"] = "PERFORM";
    ProviderType["Img"] = "IMG";
    ProviderType["IGameMedia"] = "I_GAME_MEDIA";
})(ProviderType || (ProviderType = {}));
/**
 * Specifies which type of quick amounts should be used
 * @export
 * @enum {string}
 */
export var QuickAmountsType;
(function (QuickAmountsType) {
    QuickAmountsType["FixedAmounts"] = "FIXED_AMOUNTS";
    QuickAmountsType["BalancePercents"] = "BALANCE_PERCENTS";
})(QuickAmountsType || (QuickAmountsType = {}));
/**
 * Filter for FTS to specify the fields to apply on
 * @export
 * @enum {string}
 */
export var SearchQueryField;
(function (SearchQueryField) {
    SearchQueryField["All"] = "ALL";
    SearchQueryField["TournamentName"] = "TOURNAMENT_NAME";
    SearchQueryField["CompetitorName"] = "COMPETITOR_NAME";
})(SearchQueryField || (SearchQueryField = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var TagFilterOperation;
(function (TagFilterOperation) {
    TagFilterOperation["Strict"] = "STRICT";
    TagFilterOperation["Loose"] = "LOOSE";
})(TagFilterOperation || (TagFilterOperation = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var TagRelated;
(function (TagRelated) {
    TagRelated["Client"] = "CLIENT";
    TagRelated["PaymentMethod"] = "PAYMENT_METHOD";
    TagRelated["WithdrawalMethod"] = "WITHDRAWAL_METHOD";
    TagRelated["Unknown"] = "UNKNOWN";
})(TagRelated || (TagRelated = {}));
/**
 * UNSPECIFIED OPERATOR - оператор заполнил сумму удерживаемого налога и остальные поля связанные с учетом налога самостоятельно SERVICE - рассчитанные данные по учету налога вернула Региональная команда; BO_PAYMENTS - возможны случаи сбоя, например, при недосутпности удаленной системы расчетна налогов,  тогда решение необходимо принять на стороне grpc клиента (payments) и заполнить поля согласно сценария(ий) описанных ниже
 * @export
 * @enum {string}
 */
export var TaxProvider;
(function (TaxProvider) {
    TaxProvider["Unspecified"] = "UNSPECIFIED";
    TaxProvider["Operator"] = "OPERATOR";
    TaxProvider["Service"] = "SERVICE";
    TaxProvider["BoPayments"] = "BO_PAYMENTS";
})(TaxProvider || (TaxProvider = {}));
/**
 * UNSPECIFIED DISABLED - система учета налога выключена SERVICE_UNAVAILABLE - удаленная система (на стороне региональной команды) недоступна SERVICE_ERROR - иная причина по которой не смогли получить рассчитанный налог
 * @export
 * @enum {string}
 */
export var TaxProviderErrorStatus;
(function (TaxProviderErrorStatus) {
    TaxProviderErrorStatus["Unspecified"] = "UNSPECIFIED";
    TaxProviderErrorStatus["Disabled"] = "DISABLED";
    TaxProviderErrorStatus["ServiceUnavailable"] = "SERVICE_UNAVAILABLE";
    TaxProviderErrorStatus["ServiceError"] = "SERVICE_ERROR";
})(TaxProviderErrorStatus || (TaxProviderErrorStatus = {}));
/**
 * UNSPECIFIED CLIENT - налоговым агентом является клиент ORGANIZATION - налоговым агентом является организация(или Региональная команда)
 * @export
 * @enum {string}
 */
export var TaxReporter;
(function (TaxReporter) {
    TaxReporter["Unspecified"] = "UNSPECIFIED";
    TaxReporter["Client"] = "CLIENT";
    TaxReporter["Organization"] = "ORGANIZATION";
})(TaxReporter || (TaxReporter = {}));
/**
 * UNSPECIFIED CLIENT_SELF - сумма налога удержана не будет и клиент должен будет заплатить налог самостоятельно CLIENT_WITHDRAW - сумма налога будет удержана с суммы вывода клиента  HOLD_FROM_ORG - сумма налога не будет удержана с суммы вывода клиента,  но рассчитанная сумма налога будет уплачена орагнизацией(Региональной командой)
 * @export
 * @enum {string}
 */
export var TaxSource;
(function (TaxSource) {
    TaxSource["Unspecified"] = "UNSPECIFIED";
    TaxSource["ClientSelf"] = "CLIENT_SELF";
    TaxSource["ClientWithdraw"] = "CLIENT_WITHDRAW";
    TaxSource["HoldFromOrg"] = "HOLD_FROM_ORG";
})(TaxSource || (TaxSource = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VerificationProvider;
(function (VerificationProvider) {
    VerificationProvider["SmsCode"] = "SMS_CODE";
})(VerificationProvider || (VerificationProvider = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VerificationType;
(function (VerificationType) {
    VerificationType["Withdrawal"] = "WITHDRAWAL";
})(VerificationType || (VerificationType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VirtualGameVendor;
(function (VirtualGameVendor) {
    VirtualGameVendor["Unknown"] = "UNKNOWN";
    VirtualGameVendor["Sportsbook"] = "SPORTSBOOK";
    VirtualGameVendor["BetGames"] = "BET_GAMES";
    VirtualGameVendor["TurboGames"] = "TURBO_GAMES";
    VirtualGameVendor["SportGames"] = "SPORT_GAMES";
    VirtualGameVendor["LiveGames"] = "LIVE_GAMES";
    VirtualGameVendor["Slotegrator"] = "SLOTEGRATOR";
    VirtualGameVendor["TwainSport"] = "TWAIN_SPORT";
    VirtualGameVendor["Casino"] = "CASINO";
    VirtualGameVendor["Oddingg"] = "ODDINGG";
    VirtualGameVendor["BetRadarVirtualSports"] = "BET_RADAR_VIRTUAL_SPORTS";
    VirtualGameVendor["Frigg"] = "FRIGG";
    VirtualGameVendor["External"] = "EXTERNAL";
    VirtualGameVendor["ExternalSportGames"] = "EXTERNAL_SPORT_GAMES";
    VirtualGameVendor["ExternalOddingg"] = "EXTERNAL_ODDINGG";
})(VirtualGameVendor || (VirtualGameVendor = {}));
/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create new account object
         * @param {NewAccount} [newAccount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: (newAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newAccount, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete the account object
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccount', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get client\'s account update
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountUpdates: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountUpdates', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}/updates`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of accounts.
         * @param {string} [createdFrom]
         * @param {string} [createdTo]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: (createdFrom, createdTo, offset, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (createdFrom !== undefined) {
                localVarQueryParameter['created-from'] = (createdFrom instanceof Date) ?
                    createdFrom.toISOString() :
                    createdFrom;
            }
            if (createdTo !== undefined) {
                localVarQueryParameter['created-to'] = (createdTo instanceof Date) ?
                    createdTo.toISOString() :
                    createdTo;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get information about promotion which was sent to apply
         * @param {string} accountId account id
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedPromotions: (accountId, offset, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAppliedPromotions', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}/promotions`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns default account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAccount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/accounts/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create new account object
         * @param {NewAccount} [newAccount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(newAccount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAccount(newAccount, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete the account object
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccount(accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get client\'s account update
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountUpdates(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountUpdates(accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of accounts.
         * @param {string} [createdFrom]
         * @param {string} [createdTo]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(createdFrom, createdTo, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccounts(createdFrom, createdTo, offset, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get information about promotion which was sent to apply
         * @param {string} accountId account id
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedPromotions(accountId, offset, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppliedPromotions(accountId, offset, limit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns default account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAccount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDefaultAccount(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountsApiFp(configuration);
    return {
        /**
         *
         * @summary Create new account object
         * @param {AccountsApiCreateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(requestParameters = {}, options) {
            return localVarFp.createAccount(requestParameters.newAccount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete the account object
         * @param {AccountsApiDeleteAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(requestParameters, options) {
            return localVarFp.deleteAccount(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get client\'s account update
         * @param {AccountsApiGetAccountUpdatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountUpdates(requestParameters, options) {
            return localVarFp.getAccountUpdates(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of accounts.
         * @param {AccountsApiGetAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(requestParameters = {}, options) {
            return localVarFp.getAccounts(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get information about promotion which was sent to apply
         * @param {AccountsApiGetAppliedPromotionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedPromotions(requestParameters, options) {
            return localVarFp.getAppliedPromotions(requestParameters.accountId, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns default account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAccount(options) {
            return localVarFp.getDefaultAccount(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     *
     * @summary Create new account object
     * @param {AccountsApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    createAccount(requestParameters = {}, options) {
        return AccountsApiFp(this.configuration).createAccount(requestParameters.newAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete the account object
     * @param {AccountsApiDeleteAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    deleteAccount(requestParameters, options) {
        return AccountsApiFp(this.configuration).deleteAccount(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get client\'s account update
     * @param {AccountsApiGetAccountUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccountUpdates(requestParameters, options) {
        return AccountsApiFp(this.configuration).getAccountUpdates(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of accounts.
     * @param {AccountsApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAccounts(requestParameters = {}, options) {
        return AccountsApiFp(this.configuration).getAccounts(requestParameters.createdFrom, requestParameters.createdTo, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get information about promotion which was sent to apply
     * @param {AccountsApiGetAppliedPromotionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getAppliedPromotions(requestParameters, options) {
        return AccountsApiFp(this.configuration).getAppliedPromotions(requestParameters.accountId, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns default account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    getDefaultAccount(options) {
        return AccountsApiFp(this.configuration).getDefaultAccount(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BannersApi - axios parameter creator
 * @export
 */
export const BannersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of banners
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getBanners', 'locale', locale);
            const localVarPath = `/banners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BannersApi - functional programming interface
 * @export
 */
export const BannersApiFp = function (configuration) {
    const localVarAxiosParamCreator = BannersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of banners
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBanners(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BannersApi - factory interface
 * @export
 */
export const BannersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BannersApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of banners
         * @param {BannersApiGetBannersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBanners(requestParameters, options) {
            return localVarFp.getBanners(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BannersApi - object-oriented interface
 * @export
 * @class BannersApi
 * @extends {BaseAPI}
 */
export class BannersApi extends BaseAPI {
    /**
     *
     * @summary Return a list of banners
     * @param {BannersApiGetBannersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApi
     */
    getBanners(requestParameters, options) {
        return BannersApiFp(this.configuration).getBanners(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BasketsApi - axios parameter creator
 * @export
 */
export const BasketsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Сlear the basket
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasket: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteBasket', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}/basket`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete an outcome in the basket
         * @param {string} accountId
         * @param {string} outcomeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketOutcome: (accountId, outcomeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteBasketOutcome', 'accountId', accountId);
            // verify required parameter 'outcomeId' is not null or undefined
            assertParamExists('deleteBasketOutcome', 'outcomeId', outcomeId);
            const localVarPath = `/accounts/{account-id}/basket/{outcome-id}`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"outcome-id"}}`, encodeURIComponent(String(outcomeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of outcomes in the basket
         * @param {string} accountId
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket: (accountId, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getBasket', 'accountId', accountId);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getBasket', 'locale', locale);
            const localVarPath = `/accounts/{account-id}/basket`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add an outcome to the basket
         * @param {string} accountId
         * @param {string} locale
         * @param {OutcomeIdentifier} [outcomeIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBasketOutcomes: (accountId, locale, outcomeIdentifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateBasketOutcomes', 'accountId', accountId);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('updateBasketOutcomes', 'locale', locale);
            const localVarPath = `/accounts/{account-id}/basket`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(outcomeIdentifier, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BasketsApi - functional programming interface
 * @export
 */
export const BasketsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BasketsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Сlear the basket
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasket(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBasket(accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete an outcome in the basket
         * @param {string} accountId
         * @param {string} outcomeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketOutcome(accountId, outcomeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBasketOutcome(accountId, outcomeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of outcomes in the basket
         * @param {string} accountId
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket(accountId, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBasket(accountId, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add an outcome to the basket
         * @param {string} accountId
         * @param {string} locale
         * @param {OutcomeIdentifier} [outcomeIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBasketOutcomes(accountId, locale, outcomeIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateBasketOutcomes(accountId, locale, outcomeIdentifier, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BasketsApi - factory interface
 * @export
 */
export const BasketsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BasketsApiFp(configuration);
    return {
        /**
         *
         * @summary Сlear the basket
         * @param {BasketsApiDeleteBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasket(requestParameters, options) {
            return localVarFp.deleteBasket(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete an outcome in the basket
         * @param {BasketsApiDeleteBasketOutcomeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBasketOutcome(requestParameters, options) {
            return localVarFp.deleteBasketOutcome(requestParameters.accountId, requestParameters.outcomeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of outcomes in the basket
         * @param {BasketsApiGetBasketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket(requestParameters, options) {
            return localVarFp.getBasket(requestParameters.accountId, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add an outcome to the basket
         * @param {BasketsApiUpdateBasketOutcomesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBasketOutcomes(requestParameters, options) {
            return localVarFp.updateBasketOutcomes(requestParameters.accountId, requestParameters.locale, requestParameters.outcomeIdentifier, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BasketsApi - object-oriented interface
 * @export
 * @class BasketsApi
 * @extends {BaseAPI}
 */
export class BasketsApi extends BaseAPI {
    /**
     *
     * @summary Сlear the basket
     * @param {BasketsApiDeleteBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketsApi
     */
    deleteBasket(requestParameters, options) {
        return BasketsApiFp(this.configuration).deleteBasket(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete an outcome in the basket
     * @param {BasketsApiDeleteBasketOutcomeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketsApi
     */
    deleteBasketOutcome(requestParameters, options) {
        return BasketsApiFp(this.configuration).deleteBasketOutcome(requestParameters.accountId, requestParameters.outcomeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of outcomes in the basket
     * @param {BasketsApiGetBasketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketsApi
     */
    getBasket(requestParameters, options) {
        return BasketsApiFp(this.configuration).getBasket(requestParameters.accountId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add an outcome to the basket
     * @param {BasketsApiUpdateBasketOutcomesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketsApi
     */
    updateBasketOutcomes(requestParameters, options) {
        return BasketsApiFp(this.configuration).updateBasketOutcomes(requestParameters.accountId, requestParameters.locale, requestParameters.outcomeIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BetsApi - axios parameter creator
 * @export
 */
export const BetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary delete bets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBets: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/bets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of bets for current client
         * @param {string} [accountId]
         * @param {string} [locale]
         * @param {string} [createdFrom]
         * @param {string} [createdTo]
         * @param {BetStatus} [status] Deprecated in favor of statuses field. Cannot be passed with \&#39;statuses\&#39; field
         * @param {Array<BetStatus>} [statuses] Filters bets by their status.  UNKNOWN and COMPUTED statuses are forbidden to use in this filter  and will be removed in the future out of BetStatus enum. Cannot be passed with \&#39;status\&#39; field
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {Array<BetType>} [types]
         * @param {VirtualGameVendor} [gameVendor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBets: (accountId, locale, createdFrom, createdTo, status, statuses, offset, limit, types, gameVendor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/bets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (createdFrom !== undefined) {
                localVarQueryParameter['created-from'] = (createdFrom instanceof Date) ?
                    createdFrom.toISOString() :
                    createdFrom;
            }
            if (createdTo !== undefined) {
                localVarQueryParameter['created-to'] = (createdTo instanceof Date) ?
                    createdTo.toISOString() :
                    createdTo;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (gameVendor !== undefined) {
                localVarQueryParameter['game-vendor'] = gameVendor;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of in game bet statistics for current client
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBetsStatistics: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/bets-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get cashout updates
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashoutUpdates: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getCashoutUpdates', 'accountId', accountId);
            const localVarPath = `/bets/cashout-updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Make a bet
         * @param {string} locale Needed for localization of constraint reasons and outcome name generation
         * @param {NewBetList} [newBetList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBet: (locale, newBetList, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('makeBet', 'locale', locale);
            const localVarPath = `/bets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newBetList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sell a bet
         * @param {BetSale} [betSale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellBet: (betSale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/bets/sale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(betSale, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BetsApi - functional programming interface
 * @export
 */
export const BetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BetsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary delete bets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBets(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBets(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of bets for current client
         * @param {string} [accountId]
         * @param {string} [locale]
         * @param {string} [createdFrom]
         * @param {string} [createdTo]
         * @param {BetStatus} [status] Deprecated in favor of statuses field. Cannot be passed with \&#39;statuses\&#39; field
         * @param {Array<BetStatus>} [statuses] Filters bets by their status.  UNKNOWN and COMPUTED statuses are forbidden to use in this filter  and will be removed in the future out of BetStatus enum. Cannot be passed with \&#39;status\&#39; field
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {Array<BetType>} [types]
         * @param {VirtualGameVendor} [gameVendor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBets(accountId, locale, createdFrom, createdTo, status, statuses, offset, limit, types, gameVendor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBets(accountId, locale, createdFrom, createdTo, status, statuses, offset, limit, types, gameVendor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of in game bet statistics for current client
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBetsStatistics(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBetsStatistics(accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get cashout updates
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashoutUpdates(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCashoutUpdates(accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Make a bet
         * @param {string} locale Needed for localization of constraint reasons and outcome name generation
         * @param {NewBetList} [newBetList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBet(locale, newBetList, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.makeBet(locale, newBetList, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sell a bet
         * @param {BetSale} [betSale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellBet(betSale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sellBet(betSale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BetsApi - factory interface
 * @export
 */
export const BetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BetsApiFp(configuration);
    return {
        /**
         *
         * @summary delete bets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBets(options) {
            return localVarFp.deleteBets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of bets for current client
         * @param {BetsApiGetBetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBets(requestParameters = {}, options) {
            return localVarFp.getBets(requestParameters.accountId, requestParameters.locale, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.status, requestParameters.statuses, requestParameters.offset, requestParameters.limit, requestParameters.types, requestParameters.gameVendor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of in game bet statistics for current client
         * @param {BetsApiGetBetsStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBetsStatistics(requestParameters = {}, options) {
            return localVarFp.getBetsStatistics(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get cashout updates
         * @param {BetsApiGetCashoutUpdatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashoutUpdates(requestParameters, options) {
            return localVarFp.getCashoutUpdates(requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Make a bet
         * @param {BetsApiMakeBetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeBet(requestParameters, options) {
            return localVarFp.makeBet(requestParameters.locale, requestParameters.newBetList, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sell a bet
         * @param {BetsApiSellBetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellBet(requestParameters = {}, options) {
            return localVarFp.sellBet(requestParameters.betSale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BetsApi - object-oriented interface
 * @export
 * @class BetsApi
 * @extends {BaseAPI}
 */
export class BetsApi extends BaseAPI {
    /**
     *
     * @summary delete bets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    deleteBets(options) {
        return BetsApiFp(this.configuration).deleteBets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of bets for current client
     * @param {BetsApiGetBetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    getBets(requestParameters = {}, options) {
        return BetsApiFp(this.configuration).getBets(requestParameters.accountId, requestParameters.locale, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.status, requestParameters.statuses, requestParameters.offset, requestParameters.limit, requestParameters.types, requestParameters.gameVendor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of in game bet statistics for current client
     * @param {BetsApiGetBetsStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    getBetsStatistics(requestParameters = {}, options) {
        return BetsApiFp(this.configuration).getBetsStatistics(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get cashout updates
     * @param {BetsApiGetCashoutUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    getCashoutUpdates(requestParameters, options) {
        return BetsApiFp(this.configuration).getCashoutUpdates(requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Make a bet
     * @param {BetsApiMakeBetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    makeBet(requestParameters, options) {
        return BetsApiFp(this.configuration).makeBet(requestParameters.locale, requestParameters.newBetList, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sell a bet
     * @param {BetsApiSellBetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BetsApi
     */
    sellBet(requestParameters = {}, options) {
        return BetsApiFp(this.configuration).sellBet(requestParameters.betSale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BroadcastApi - axios parameter creator
 * @export
 */
export const BroadcastApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns an Event\'s broadcast
         * @param {number} eventId
         * @param {string} redirectUrl
         * @param {string} [locale]
         * @param {string} [platform]
         * @param {BroadcastType} [preferredBroadcastType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventBroadcast: (eventId, redirectUrl, locale, platform, preferredBroadcastType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventBroadcast', 'eventId', eventId);
            // verify required parameter 'redirectUrl' is not null or undefined
            assertParamExists('getEventBroadcast', 'redirectUrl', redirectUrl);
            const localVarPath = `/events/{event-id}/broadcasts`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }
            if (preferredBroadcastType !== undefined) {
                localVarQueryParameter['preferred-broadcast-type'] = preferredBroadcastType;
            }
            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirect-url'] = redirectUrl;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns availability of events broadcasts
         * @param {Array<number>} eventIds
         * @param {string} [platform]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsBroadcastsAvailability: (eventIds, platform, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventIds' is not null or undefined
            assertParamExists('getEventsBroadcastsAvailability', 'eventIds', eventIds);
            const localVarPath = `/events/broadcast-availabilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (eventIds) {
                localVarQueryParameter['event-ids'] = eventIds;
            }
            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BroadcastApi - functional programming interface
 * @export
 */
export const BroadcastApiFp = function (configuration) {
    const localVarAxiosParamCreator = BroadcastApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns an Event\'s broadcast
         * @param {number} eventId
         * @param {string} redirectUrl
         * @param {string} [locale]
         * @param {string} [platform]
         * @param {BroadcastType} [preferredBroadcastType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventBroadcast(eventId, redirectUrl, locale, platform, preferredBroadcastType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventBroadcast(eventId, redirectUrl, locale, platform, preferredBroadcastType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns availability of events broadcasts
         * @param {Array<number>} eventIds
         * @param {string} [platform]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsBroadcastsAvailability(eventIds, platform, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventsBroadcastsAvailability(eventIds, platform, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BroadcastApi - factory interface
 * @export
 */
export const BroadcastApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BroadcastApiFp(configuration);
    return {
        /**
         *
         * @summary Returns an Event\'s broadcast
         * @param {BroadcastApiGetEventBroadcastRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventBroadcast(requestParameters, options) {
            return localVarFp.getEventBroadcast(requestParameters.eventId, requestParameters.redirectUrl, requestParameters.locale, requestParameters.platform, requestParameters.preferredBroadcastType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns availability of events broadcasts
         * @param {BroadcastApiGetEventsBroadcastsAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsBroadcastsAvailability(requestParameters, options) {
            return localVarFp.getEventsBroadcastsAvailability(requestParameters.eventIds, requestParameters.platform, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BroadcastApi - object-oriented interface
 * @export
 * @class BroadcastApi
 * @extends {BaseAPI}
 */
export class BroadcastApi extends BaseAPI {
    /**
     *
     * @summary Returns an Event\'s broadcast
     * @param {BroadcastApiGetEventBroadcastRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastApi
     */
    getEventBroadcast(requestParameters, options) {
        return BroadcastApiFp(this.configuration).getEventBroadcast(requestParameters.eventId, requestParameters.redirectUrl, requestParameters.locale, requestParameters.platform, requestParameters.preferredBroadcastType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns availability of events broadcasts
     * @param {BroadcastApiGetEventsBroadcastsAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BroadcastApi
     */
    getEventsBroadcastsAvailability(requestParameters, options) {
        return BroadcastApiFp(this.configuration).getEventsBroadcastsAvailability(requestParameters.eventIds, requestParameters.platform, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CaptchaProvidersApi - axios parameter creator
 * @export
 */
export const CaptchaProvidersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return list of captcha providers configured in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptchaProviders: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/captcha/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CaptchaProvidersApi - functional programming interface
 * @export
 */
export const CaptchaProvidersApiFp = function (configuration) {
    const localVarAxiosParamCreator = CaptchaProvidersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return list of captcha providers configured in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptchaProviders(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCaptchaProviders(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CaptchaProvidersApi - factory interface
 * @export
 */
export const CaptchaProvidersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CaptchaProvidersApiFp(configuration);
    return {
        /**
         *
         * @summary Return list of captcha providers configured in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaptchaProviders(options) {
            return localVarFp.getCaptchaProviders(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CaptchaProvidersApi - object-oriented interface
 * @export
 * @class CaptchaProvidersApi
 * @extends {BaseAPI}
 */
export class CaptchaProvidersApi extends BaseAPI {
    /**
     *
     * @summary Return list of captcha providers configured in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaptchaProvidersApi
     */
    getCaptchaProviders(options) {
        return CaptchaProvidersApiFp(this.configuration).getCaptchaProviders(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ControlQuestionsApi - axios parameter creator
 * @export
 */
export const ControlQuestionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of control questions
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlQuestions: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/control-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ControlQuestionsApi - functional programming interface
 * @export
 */
export const ControlQuestionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ControlQuestionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of control questions
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlQuestions(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getControlQuestions(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ControlQuestionsApi - factory interface
 * @export
 */
export const ControlQuestionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ControlQuestionsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of control questions
         * @param {ControlQuestionsApiGetControlQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlQuestions(requestParameters = {}, options) {
            return localVarFp.getControlQuestions(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ControlQuestionsApi - object-oriented interface
 * @export
 * @class ControlQuestionsApi
 * @extends {BaseAPI}
 */
export class ControlQuestionsApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of control questions
     * @param {ControlQuestionsApiGetControlQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlQuestionsApi
     */
    getControlQuestions(requestParameters = {}, options) {
        return ControlQuestionsApiFp(this.configuration).getControlQuestions(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of countries.
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of countries.
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountries(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CountriesApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of countries.
         * @param {CountriesApiGetCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(requestParameters = {}, options) {
            return localVarFp.getCountries(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of countries.
     * @param {CountriesApiGetCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    getCountries(requestParameters = {}, options) {
        return CountriesApiFp(this.configuration).getCountries(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CouponsApi - axios parameter creator
 * @export
 */
export const CouponsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {string} accountId account id
         * @param {Array<AppliedCouponStatus>} [applyStatuses]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons: (accountId, applyStatuses, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAppliedCoupons', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}/coupons`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (applyStatuses) {
                localVarQueryParameter['apply-statuses'] = applyStatuses;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CouponsApi - functional programming interface
 * @export
 */
export const CouponsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {string} accountId account id
         * @param {Array<AppliedCouponStatus>} [applyStatuses]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons(accountId, applyStatuses, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppliedCoupons(accountId, applyStatuses, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CouponsApi - factory interface
 * @export
 */
export const CouponsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CouponsApiFp(configuration);
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {CouponsApiGetAppliedCouponsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons(requestParameters, options) {
            return localVarFp.getAppliedCoupons(requestParameters.accountId, requestParameters.applyStatuses, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
export class CouponsApi extends BaseAPI {
    /**
     *
     * @summary Get information about coupons which was sent to apply
     * @param {CouponsApiGetAppliedCouponsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    getAppliedCoupons(requestParameters, options) {
        return CouponsApiFp(this.configuration).getAppliedCoupons(requestParameters.accountId, requestParameters.applyStatuses, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of currencies
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of currencies
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrencies(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CurrenciesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of currencies
         * @param {CurrenciesApiGetCurrenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(requestParameters = {}, options) {
            return localVarFp.getCurrencies(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of currencies
     * @param {CurrenciesApiGetCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    getCurrencies(requestParameters = {}, options) {
        return CurrenciesApiFp(this.configuration).getCurrencies(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EntityTagsApi - axios parameter creator
 * @export
 */
export const EntityTagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a list of all entity tags of the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTags: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/entity-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EntityTagsApi - functional programming interface
 * @export
 */
export const EntityTagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EntityTagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a list of all entity tags of the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTags(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEntityTags(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EntityTagsApi - factory interface
 * @export
 */
export const EntityTagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EntityTagsApiFp(configuration);
    return {
        /**
         *
         * @summary Get a list of all entity tags of the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityTags(options) {
            return localVarFp.getEntityTags(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntityTagsApi - object-oriented interface
 * @export
 * @class EntityTagsApi
 * @extends {BaseAPI}
 */
export class EntityTagsApi extends BaseAPI {
    /**
     *
     * @summary Get a list of all entity tags of the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTagsApi
     */
    getEntityTags(options) {
        return EntityTagsApiFp(this.configuration).getEntityTags(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventProbabilitiesApi - axios parameter creator
 * @export
 */
export const EventProbabilitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities: (eventId, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventProbabilities', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/probabilities`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {number} eventId
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates: (eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventProbabilitiesUpdates', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/probabilities/updates`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (cursorResetPolicy !== undefined) {
                localVarQueryParameter['cursor-reset-policy'] = cursorResetPolicy;
            }
            if (reloadIdsToSkip) {
                localVarQueryParameter['reload-ids-to-skip'] = reloadIdsToSkip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of hot probabilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHotProbabilityGroups: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/hot-probabilities/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventProbabilitiesApi - functional programming interface
 * @export
 */
export const EventProbabilitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventProbabilitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities(eventId, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventProbabilities(eventId, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {number} eventId
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates(eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventProbabilitiesUpdates(eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of hot probabilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHotProbabilityGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHotProbabilityGroups(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventProbabilitiesApi - factory interface
 * @export
 */
export const EventProbabilitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventProbabilitiesApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {EventProbabilitiesApiGetEventProbabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities(requestParameters, options) {
            return localVarFp.getEventProbabilities(requestParameters.eventId, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {EventProbabilitiesApiGetEventProbabilitiesUpdatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates(requestParameters, options) {
            return localVarFp.getEventProbabilitiesUpdates(requestParameters.eventId, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.reloadIdsToSkip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of hot probabilities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHotProbabilityGroups(options) {
            return localVarFp.getHotProbabilityGroups(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventProbabilitiesApi - object-oriented interface
 * @export
 * @class EventProbabilitiesApi
 * @extends {BaseAPI}
 */
export class EventProbabilitiesApi extends BaseAPI {
    /**
     *
     * @summary Returns a Event Probabilities object
     * @param {EventProbabilitiesApiGetEventProbabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventProbabilitiesApi
     */
    getEventProbabilities(requestParameters, options) {
        return EventProbabilitiesApiFp(this.configuration).getEventProbabilities(requestParameters.eventId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get event\'s probabilities updates
     * @param {EventProbabilitiesApiGetEventProbabilitiesUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventProbabilitiesApi
     */
    getEventProbabilitiesUpdates(requestParameters, options) {
        return EventProbabilitiesApiFp(this.configuration).getEventProbabilitiesUpdates(requestParameters.eventId, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.reloadIdsToSkip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of hot probabilities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventProbabilitiesApi
     */
    getHotProbabilityGroups(options) {
        return EventProbabilitiesApiFp(this.configuration).getHotProbabilityGroups(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventResultsApi - axios parameter creator
 * @export
 */
export const EventResultsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return counters for event results
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [tournamentIds]
         * @param {string} [scheduledFrom] Search for event results that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for event results that are scheduled at or before the specified date and time.
         * @param {CompletionStatus} [completionStatus]
         * @param {Array<EventStatus>} [statuses]
         * @param {string} [locale]
         * @param {boolean} [aggregateByGeneric] Set if need to aggregate by generic sport ids. For example if there is CyberSport(id&#x3D;105) and is generic for Dota2(id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2 will be counted as CyberSport
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Define the event result fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultCounters: (sportIds, tournamentIds, scheduledFrom, scheduledTo, completionStatus, statuses, locale, aggregateByGeneric, includeSubsports, searchQuery, searchQueryFields, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/counters/event-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (tournamentIds) {
                localVarQueryParameter['tournament-ids'] = tournamentIds;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (completionStatus !== undefined) {
                localVarQueryParameter['completion-status'] = completionStatus;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['search-query'] = searchQuery;
            }
            if (searchQueryFields) {
                localVarQueryParameter['search-query-fields'] = searchQueryFields;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of event results
         * @param {string} [date]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [locale]
         * @param {Array<number>} [ids]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventResults: (date, sportId, sportIds, offset, limit, locale, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/event-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sportId'] = sportId;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of event results
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [ids]
         * @param {Array<number>} [sportIds]
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentIds]
         * @param {string} [scheduledFrom] Search for event results that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for event results that are scheduled at or before the specified date and time.
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Specify the event result fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {CompletionStatus} [completionStatus]
         * @param {Array<EventStatus>} [statuses]
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;eventWeight.{weight_category_system_code}.{direction}\&#39; or    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;scheduledAt.desc\&quot;] - [\&quot;eventWeight.topCyber.asc\&quot;, \&quot;scheduledAt.desc\&quot;] **Sort fields** for event results are:   - completionStatus   - scheduledAt   - tournamentId   - sportId  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {PaginationKeyDirection} [pageKeyDirection] Direction of pagination. Default value is FORWARD
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultsV2: (locale, ids, sportIds, includeSubsports, tournamentIds, scheduledFrom, scheduledTo, searchQuery, searchQueryFields, completionStatus, statuses, sort, pageKey, pageKeyDirection, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/event-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (tournamentIds) {
                localVarQueryParameter['tournament-ids'] = tournamentIds;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['search-query'] = searchQuery;
            }
            if (searchQueryFields) {
                localVarQueryParameter['search-query-fields'] = searchQueryFields;
            }
            if (completionStatus !== undefined) {
                localVarQueryParameter['completion-status'] = completionStatus;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageKey !== undefined) {
                localVarQueryParameter['page-key'] = pageKey;
            }
            if (pageKeyDirection !== undefined) {
                localVarQueryParameter['page-key-direction'] = pageKeyDirection;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page-size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventResultsApi - functional programming interface
 * @export
 */
export const EventResultsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventResultsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return counters for event results
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [tournamentIds]
         * @param {string} [scheduledFrom] Search for event results that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for event results that are scheduled at or before the specified date and time.
         * @param {CompletionStatus} [completionStatus]
         * @param {Array<EventStatus>} [statuses]
         * @param {string} [locale]
         * @param {boolean} [aggregateByGeneric] Set if need to aggregate by generic sport ids. For example if there is CyberSport(id&#x3D;105) and is generic for Dota2(id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2 will be counted as CyberSport
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Define the event result fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultCounters(sportIds, tournamentIds, scheduledFrom, scheduledTo, completionStatus, statuses, locale, aggregateByGeneric, includeSubsports, searchQuery, searchQueryFields, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventResultCounters(sportIds, tournamentIds, scheduledFrom, scheduledTo, completionStatus, statuses, locale, aggregateByGeneric, includeSubsports, searchQuery, searchQueryFields, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of event results
         * @param {string} [date]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [locale]
         * @param {Array<number>} [ids]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventResults(date, sportId, sportIds, offset, limit, locale, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventResults(date, sportId, sportIds, offset, limit, locale, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of event results
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [ids]
         * @param {Array<number>} [sportIds]
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentIds]
         * @param {string} [scheduledFrom] Search for event results that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for event results that are scheduled at or before the specified date and time.
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Specify the event result fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {CompletionStatus} [completionStatus]
         * @param {Array<EventStatus>} [statuses]
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;eventWeight.{weight_category_system_code}.{direction}\&#39; or    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;scheduledAt.desc\&quot;] - [\&quot;eventWeight.topCyber.asc\&quot;, \&quot;scheduledAt.desc\&quot;] **Sort fields** for event results are:   - completionStatus   - scheduledAt   - tournamentId   - sportId  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {PaginationKeyDirection} [pageKeyDirection] Direction of pagination. Default value is FORWARD
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultsV2(locale, ids, sportIds, includeSubsports, tournamentIds, scheduledFrom, scheduledTo, searchQuery, searchQueryFields, completionStatus, statuses, sort, pageKey, pageKeyDirection, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventResultsV2(locale, ids, sportIds, includeSubsports, tournamentIds, scheduledFrom, scheduledTo, searchQuery, searchQueryFields, completionStatus, statuses, sort, pageKey, pageKeyDirection, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventResultsApi - factory interface
 * @export
 */
export const EventResultsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventResultsApiFp(configuration);
    return {
        /**
         *
         * @summary Return counters for event results
         * @param {EventResultsApiGetEventResultCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultCounters(requestParameters = {}, options) {
            return localVarFp.getEventResultCounters(requestParameters.sportIds, requestParameters.tournamentIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.completionStatus, requestParameters.statuses, requestParameters.locale, requestParameters.aggregateByGeneric, requestParameters.includeSubsports, requestParameters.searchQuery, requestParameters.searchQueryFields, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of event results
         * @param {EventResultsApiGetEventResultsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventResults(requestParameters = {}, options) {
            return localVarFp.getEventResults(requestParameters.date, requestParameters.sportId, requestParameters.sportIds, requestParameters.offset, requestParameters.limit, requestParameters.locale, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of event results
         * @param {EventResultsApiGetEventResultsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventResultsV2(requestParameters = {}, options) {
            return localVarFp.getEventResultsV2(requestParameters.locale, requestParameters.ids, requestParameters.sportIds, requestParameters.includeSubsports, requestParameters.tournamentIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.completionStatus, requestParameters.statuses, requestParameters.sort, requestParameters.pageKey, requestParameters.pageKeyDirection, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventResultsApi - object-oriented interface
 * @export
 * @class EventResultsApi
 * @extends {BaseAPI}
 */
export class EventResultsApi extends BaseAPI {
    /**
     *
     * @summary Return counters for event results
     * @param {EventResultsApiGetEventResultCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventResultsApi
     */
    getEventResultCounters(requestParameters = {}, options) {
        return EventResultsApiFp(this.configuration).getEventResultCounters(requestParameters.sportIds, requestParameters.tournamentIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.completionStatus, requestParameters.statuses, requestParameters.locale, requestParameters.aggregateByGeneric, requestParameters.includeSubsports, requestParameters.searchQuery, requestParameters.searchQueryFields, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of event results
     * @param {EventResultsApiGetEventResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventResultsApi
     */
    getEventResults(requestParameters = {}, options) {
        return EventResultsApiFp(this.configuration).getEventResults(requestParameters.date, requestParameters.sportId, requestParameters.sportIds, requestParameters.offset, requestParameters.limit, requestParameters.locale, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of event results
     * @param {EventResultsApiGetEventResultsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventResultsApi
     */
    getEventResultsV2(requestParameters = {}, options) {
        return EventResultsApiFp(this.configuration).getEventResultsV2(requestParameters.locale, requestParameters.ids, requestParameters.sportIds, requestParameters.includeSubsports, requestParameters.tournamentIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.completionStatus, requestParameters.statuses, requestParameters.sort, requestParameters.pageKey, requestParameters.pageKeyDirection, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventTagsApi - axios parameter creator
 * @export
 */
export const EventTagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a list of all event tags in the system
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventTags: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/event-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventTagsApi - functional programming interface
 * @export
 */
export const EventTagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventTagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a list of all event tags in the system
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventTags(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventTags(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventTagsApi - factory interface
 * @export
 */
export const EventTagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventTagsApiFp(configuration);
    return {
        /**
         *
         * @summary Get a list of all event tags in the system
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventTags(options) {
            return localVarFp.getEventTags(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventTagsApi - object-oriented interface
 * @export
 * @class EventTagsApi
 * @extends {BaseAPI}
 */
export class EventTagsApi extends BaseAPI {
    /**
     *
     * @summary Get a list of all event tags in the system
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventTagsApi
     */
    getEventTags(options) {
        return EventTagsApiFp(this.configuration).getEventTags(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a Event object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {boolean} [withCursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent: (eventId, locale, withCursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEvent', 'eventId', eventId);
            const localVarPath = `/events/{event-id}`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (withCursor !== undefined) {
                localVarQueryParameter['with-cursor'] = withCursor;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return counters for events
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [tournamentIds]
         * @param {Array<ActiveEventStatus>} [statuses]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom] Search for events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for events that are scheduled at or before the specified date and time.
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an event. For example,  if there is event1 with tags [1, 3, 6] and event2 with [2, 3, 5], and you search for tag IDs [1, 2] with  LOOSE, you will get both event1 and event2. However, when you search for [1, 3] with STRICT, only event1  will be returned. Note: The default value is LOOSE.
         * @param {Array<string>} [providerIds] Use integration-types instead
         * @param {Array<EventIntegrationType>} [integrationTypes] Search by having any third party integration types
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {string} [locale]
         * @param {Array<SearchQueryField>} [searchQueryFields] Define the event fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {boolean} [hasActiveLineOutcomes] Only applied to LINE events. Checks if LINE event has active line outcomes
         * @param {boolean} [hasLineOutcomes] If set to true then Line events without outcomes will be excluded from counters. If set to false or missing will do nothing
         * @param {boolean} [aggregateByGeneric] Set if need to aggregate by generic sport ids. For example if there is CyberSport(id&#x3D;105) and is generic for Dota2(id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2 will be counted as CyberSport
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {string} [fiql] FIQL string for API consumers to be able to express complex queries. Cannot be passed with other filters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventCounters: (sportIds, tournamentIds, statuses, live, scheduledFrom, scheduledTo, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, locale, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, aggregateByGeneric, includeSubsports, fiql, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/counters/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (tournamentIds) {
                localVarQueryParameter['tournament-ids'] = tournamentIds;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (live !== undefined) {
                localVarQueryParameter['live'] = live;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            if (providerIds) {
                localVarQueryParameter['provider-ids'] = providerIds;
            }
            if (integrationTypes) {
                localVarQueryParameter['integration-types'] = integrationTypes;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['search-query'] = searchQuery;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (searchQueryFields) {
                localVarQueryParameter['search-query-fields'] = searchQueryFields;
            }
            if (hasActiveLineOutcomes !== undefined) {
                localVarQueryParameter['has-active-line-outcomes'] = hasActiveLineOutcomes;
            }
            if (hasLineOutcomes !== undefined) {
                localVarQueryParameter['has-line-outcomes'] = hasLineOutcomes;
            }
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (fiql !== undefined) {
                localVarQueryParameter['fiql'] = fiql;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities: (eventId, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventProbabilities', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/probabilities`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {number} eventId
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates: (eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventProbabilitiesUpdates', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/probabilities/updates`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (cursorResetPolicy !== undefined) {
                localVarQueryParameter['cursor-reset-policy'] = cursorResetPolicy;
            }
            if (reloadIdsToSkip) {
                localVarQueryParameter['reload-ids-to-skip'] = reloadIdsToSkip;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns statistics for an event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventStatistics', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/statistics`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is a deprecated endpoint, consider using /v2/events for better functionality and performance  Retrieves a list of events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns only top events.   - `top=false` or omit `top`: Returns all events.
         * @summary Returns a list of events.
         * @param {string} [locale]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {number} [tournamentId]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {Array<number>} [ids]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {boolean} [withCursor]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEvents: (locale, sportId, sportIds, tournamentId, live, scheduledFrom, scheduledTo, top, ids, tagIds, tagFilterOperation, withCursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (tournamentId !== undefined) {
                localVarQueryParameter['tournament-id'] = tournamentId;
            }
            if (live !== undefined) {
                localVarQueryParameter['live'] = live;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            if (withCursor !== undefined) {
                localVarQueryParameter['with-cursor'] = withCursor;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Receive updates for events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns updates for events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns updates for events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns updates only for top events.   - `top=false` or omit `top`: Returns updates for all events.
         * @summary Get updates for events by SSE
         * @param {string} [locale]
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {number} [sportId]
         * @param {number} [tournamentId]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsUpdates: (locale, cursor, cursorResetPolicy, sportId, tournamentId, live, scheduledFrom, scheduledTo, top, reloadIdsToSkip, tagIds, tagFilterOperation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/events/updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (cursorResetPolicy !== undefined) {
                localVarQueryParameter['cursor-reset-policy'] = cursorResetPolicy;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (tournamentId !== undefined) {
                localVarQueryParameter['tournament-id'] = tournamentId;
            }
            if (live !== undefined) {
                localVarQueryParameter['live'] = live;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (reloadIdsToSkip) {
                localVarQueryParameter['reload-ids-to-skip'] = reloadIdsToSkip;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [sportIds]
         * @param {boolean} [includeSubsports] Search by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentIds]
         * @param {Array<ActiveEventStatus>} [statuses]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom] Search for events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for events that are scheduled at or before the specified date and time.
         * @param {Array<number>} [ids] Search by event IDs.  Note: This filter does not work with other filters. If both event IDs and any other filters are provided, a validation error will be thrown.
         * @param {Array<number>} [tagIds] Filter by tags
         * @param {TagFilterOperation} [tagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an event. For example,  if there is event1 with tags [1, 3, 6] and event2 with [2, 3, 5], and you search for tag IDs [1, 2] with  LOOSE, you will get both event1 and event2. However, when you search for [1, 3] with STRICT, only event1  will be returned. Note: The default value is LOOSE.
         * @param {Array<string>} [providerIds] Use integration-types instead
         * @param {Array<EventIntegrationType>} [integrationTypes] Search by third party integration types. Event matches this filter if any of provided integrations exists for this event
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Specify event fields that are used for search by search-query. Default value is ALL
         * @param {boolean} [hasActiveLineOutcomes] Only applied to LINE events. Checks if LINE event has active line outcomes
         * @param {boolean} [hasLineOutcomes] If set to true then Line events without outcomes will be excluded from response. If set to false or missing will do nothing
         * @param {string} [fiql] FIQL string for API consumers to be able to express complex queries. Cannot be passed with other filters.
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;eventWeight.{weight_category_system_code}.{direction}\&#39; or    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;scheduledAt.desc\&quot;] - [\&quot;groupOrder.asc\&quot;, \&quot;scheduledAt.desc\&quot;] - [\&quot;eventWeight.topCyber.asc\&quot;, \&quot;scheduledAt.desc\&quot;] **Sort fields** for events are:   - live   - providers   - scheduledAt   - sportOrder   - groupOrder   - tournamentId   - eventTagOrder   - tournamentTagOrder  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {PaginationKeyDirection} [pageKeyDirection] Direction of pagination. Default value is FORWARD
         * @param {number} [pageSize]
         * @param {boolean} [withCursor] If set to true response will include cursor that is used for SSE subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsV2: (locale, sportIds, includeSubsports, tournamentIds, statuses, live, scheduledFrom, scheduledTo, ids, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, fiql, sort, pageKey, pageKeyDirection, pageSize, withCursor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (tournamentIds) {
                localVarQueryParameter['tournament-ids'] = tournamentIds;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (live !== undefined) {
                localVarQueryParameter['live'] = live;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            if (providerIds) {
                localVarQueryParameter['provider-ids'] = providerIds;
            }
            if (integrationTypes) {
                localVarQueryParameter['integration-types'] = integrationTypes;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['search-query'] = searchQuery;
            }
            if (searchQueryFields) {
                localVarQueryParameter['search-query-fields'] = searchQueryFields;
            }
            if (hasActiveLineOutcomes !== undefined) {
                localVarQueryParameter['has-active-line-outcomes'] = hasActiveLineOutcomes;
            }
            if (hasLineOutcomes !== undefined) {
                localVarQueryParameter['has-line-outcomes'] = hasLineOutcomes;
            }
            if (fiql !== undefined) {
                localVarQueryParameter['fiql'] = fiql;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageKey !== undefined) {
                localVarQueryParameter['page-key'] = pageKey;
            }
            if (pageKeyDirection !== undefined) {
                localVarQueryParameter['page-key-direction'] = pageKeyDirection;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page-size'] = pageSize;
            }
            if (withCursor !== undefined) {
                localVarQueryParameter['with-cursor'] = withCursor;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a list of scheduled events based on the provided filters. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.
         * @summary Returns a list of events
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {string} [locale]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledLiveEvents: (scheduledFrom, scheduledTo, offset, limit, sportId, sportIds, locale, tagIds, tagFilterOperation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scheduled-live-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of events searched by
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents: (query, locale, sportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchEvents', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('searchEvents', 'locale', locale);
            const localVarPath = `/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a Event object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {boolean} [withCursor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(eventId, locale, withCursor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvent(eventId, locale, withCursor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return counters for events
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [tournamentIds]
         * @param {Array<ActiveEventStatus>} [statuses]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom] Search for events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for events that are scheduled at or before the specified date and time.
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an event. For example,  if there is event1 with tags [1, 3, 6] and event2 with [2, 3, 5], and you search for tag IDs [1, 2] with  LOOSE, you will get both event1 and event2. However, when you search for [1, 3] with STRICT, only event1  will be returned. Note: The default value is LOOSE.
         * @param {Array<string>} [providerIds] Use integration-types instead
         * @param {Array<EventIntegrationType>} [integrationTypes] Search by having any third party integration types
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {string} [locale]
         * @param {Array<SearchQueryField>} [searchQueryFields] Define the event fields that are used for search by search-query. If empty or null and search-query is specified then uses ALL as default
         * @param {boolean} [hasActiveLineOutcomes] Only applied to LINE events. Checks if LINE event has active line outcomes
         * @param {boolean} [hasLineOutcomes] If set to true then Line events without outcomes will be excluded from counters. If set to false or missing will do nothing
         * @param {boolean} [aggregateByGeneric] Set if need to aggregate by generic sport ids. For example if there is CyberSport(id&#x3D;105) and is generic for Dota2(id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2 will be counted as CyberSport
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {string} [fiql] FIQL string for API consumers to be able to express complex queries. Cannot be passed with other filters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventCounters(sportIds, tournamentIds, statuses, live, scheduledFrom, scheduledTo, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, locale, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, aggregateByGeneric, includeSubsports, fiql, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventCounters(sportIds, tournamentIds, statuses, live, scheduledFrom, scheduledTo, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, locale, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, aggregateByGeneric, includeSubsports, fiql, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {number} eventId
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities(eventId, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventProbabilities(eventId, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {number} eventId
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates(eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventProbabilitiesUpdates(eventId, cursor, cursorResetPolicy, reloadIdsToSkip, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns statistics for an event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventStatistics(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This is a deprecated endpoint, consider using /v2/events for better functionality and performance  Retrieves a list of events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns only top events.   - `top=false` or omit `top`: Returns all events.
         * @summary Returns a list of events.
         * @param {string} [locale]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {number} [tournamentId]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {Array<number>} [ids]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {boolean} [withCursor]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEvents(locale, sportId, sportIds, tournamentId, live, scheduledFrom, scheduledTo, top, ids, tagIds, tagFilterOperation, withCursor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEvents(locale, sportId, sportIds, tournamentId, live, scheduledFrom, scheduledTo, top, ids, tagIds, tagFilterOperation, withCursor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Receive updates for events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns updates for events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns updates for events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns updates only for top events.   - `top=false` or omit `top`: Returns updates for all events.
         * @summary Get updates for events by SSE
         * @param {string} [locale]
         * @param {string} [cursor]
         * @param {CursorResetPolicy} [cursorResetPolicy]
         * @param {number} [sportId]
         * @param {number} [tournamentId]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {Array<string>} [reloadIdsToSkip]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsUpdates(locale, cursor, cursorResetPolicy, sportId, tournamentId, live, scheduledFrom, scheduledTo, top, reloadIdsToSkip, tagIds, tagFilterOperation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventsUpdates(locale, cursor, cursorResetPolicy, sportId, tournamentId, live, scheduledFrom, scheduledTo, top, reloadIdsToSkip, tagIds, tagFilterOperation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [sportIds]
         * @param {boolean} [includeSubsports] Search by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, records from both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentIds]
         * @param {Array<ActiveEventStatus>} [statuses]
         * @param {boolean} [live]
         * @param {string} [scheduledFrom] Search for events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for events that are scheduled at or before the specified date and time.
         * @param {Array<number>} [ids] Search by event IDs.  Note: This filter does not work with other filters. If both event IDs and any other filters are provided, a validation error will be thrown.
         * @param {Array<number>} [tagIds] Filter by tags
         * @param {TagFilterOperation} [tagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an event. For example,  if there is event1 with tags [1, 3, 6] and event2 with [2, 3, 5], and you search for tag IDs [1, 2] with  LOOSE, you will get both event1 and event2. However, when you search for [1, 3] with STRICT, only event1  will be returned. Note: The default value is LOOSE.
         * @param {Array<string>} [providerIds] Use integration-types instead
         * @param {Array<EventIntegrationType>} [integrationTypes] Search by third party integration types. Event matches this filter if any of provided integrations exists for this event
         * @param {string} [searchQuery] Search in the name translations of the fields defined by the \&#39;search-query-fields\&#39; filter.  During the search, we use a disjunction of fuzzy search and wildcard search. Fuzzy search allows up to 2  mistakes in the provided search string (for example, \&#39;Barcelona\&#39; will be returned for \&#39;Bercelone\&#39; search  string).  Wildcard search allows searching by part of a word (without any mistakes), meaning \&#39;Barcelona\&#39; will be  correctly returned by the search string \&#39;celon\&#39;. If the search query contains multiple words, we split them and perform a search for each separately,  returning only events that match all the words. For example, when you search for \&#39;Barcelona Madrid\&#39;, you  will get an event with competitors \&#39;Barcelona\&#39; and \&#39;Real Madrid\&#39;, but not \&#39;Barcelona\&#39; and \&#39;Manchester\&#39;.  When a locale filter is specified, the system looks for translations in the provided locale. However, if  there are no translations in the provided locale, it defaults to the name of the Tournament or Competitor.
         * @param {Array<SearchQueryField>} [searchQueryFields] Specify event fields that are used for search by search-query. Default value is ALL
         * @param {boolean} [hasActiveLineOutcomes] Only applied to LINE events. Checks if LINE event has active line outcomes
         * @param {boolean} [hasLineOutcomes] If set to true then Line events without outcomes will be excluded from response. If set to false or missing will do nothing
         * @param {string} [fiql] FIQL string for API consumers to be able to express complex queries. Cannot be passed with other filters.
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;eventWeight.{weight_category_system_code}.{direction}\&#39; or    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;scheduledAt.desc\&quot;] - [\&quot;groupOrder.asc\&quot;, \&quot;scheduledAt.desc\&quot;] - [\&quot;eventWeight.topCyber.asc\&quot;, \&quot;scheduledAt.desc\&quot;] **Sort fields** for events are:   - live   - providers   - scheduledAt   - sportOrder   - groupOrder   - tournamentId   - eventTagOrder   - tournamentTagOrder  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {PaginationKeyDirection} [pageKeyDirection] Direction of pagination. Default value is FORWARD
         * @param {number} [pageSize]
         * @param {boolean} [withCursor] If set to true response will include cursor that is used for SSE subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsV2(locale, sportIds, includeSubsports, tournamentIds, statuses, live, scheduledFrom, scheduledTo, ids, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, fiql, sort, pageKey, pageKeyDirection, pageSize, withCursor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventsV2(locale, sportIds, includeSubsports, tournamentIds, statuses, live, scheduledFrom, scheduledTo, ids, tagIds, tagFilterOperation, providerIds, integrationTypes, searchQuery, searchQueryFields, hasActiveLineOutcomes, hasLineOutcomes, fiql, sort, pageKey, pageKeyDirection, pageSize, withCursor, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves a list of scheduled events based on the provided filters. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.
         * @summary Returns a list of events
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {number} [sportId]
         * @param {Array<number>} [sportIds]
         * @param {string} [locale]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledLiveEvents(scheduledFrom, scheduledTo, offset, limit, sportId, sportIds, locale, tagIds, tagFilterOperation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScheduledLiveEvents(scheduledFrom, scheduledTo, offset, limit, sportId, sportIds, locale, tagIds, tagFilterOperation, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of events searched by
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents(query, locale, sportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchEvents(query, locale, sportId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a Event object
         * @param {EventsApiGetEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(requestParameters, options) {
            return localVarFp.getEvent(requestParameters.eventId, requestParameters.locale, requestParameters.withCursor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return counters for events
         * @param {EventsApiGetEventCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventCounters(requestParameters = {}, options) {
            return localVarFp.getEventCounters(requestParameters.sportIds, requestParameters.tournamentIds, requestParameters.statuses, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.providerIds, requestParameters.integrationTypes, requestParameters.searchQuery, requestParameters.locale, requestParameters.searchQueryFields, requestParameters.hasActiveLineOutcomes, requestParameters.hasLineOutcomes, requestParameters.aggregateByGeneric, requestParameters.includeSubsports, requestParameters.fiql, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a Event Probabilities object
         * @param {EventsApiGetEventProbabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEventProbabilities(requestParameters, options) {
            return localVarFp.getEventProbabilities(requestParameters.eventId, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get event\'s probabilities updates
         * @param {EventsApiGetEventProbabilitiesUpdatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventProbabilitiesUpdates(requestParameters, options) {
            return localVarFp.getEventProbabilitiesUpdates(requestParameters.eventId, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.reloadIdsToSkip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns statistics for an event
         * @param {EventsApiGetEventStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics(requestParameters, options) {
            return localVarFp.getEventStatistics(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * This is a deprecated endpoint, consider using /v2/events for better functionality and performance  Retrieves a list of events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns only top events.   - `top=false` or omit `top`: Returns all events.
         * @summary Returns a list of events.
         * @param {EventsApiGetEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getEvents(requestParameters = {}, options) {
            return localVarFp.getEvents(requestParameters.locale, requestParameters.sportId, requestParameters.sportIds, requestParameters.tournamentId, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.ids, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.withCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Receive updates for events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns updates for events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns updates for events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns updates only for top events.   - `top=false` or omit `top`: Returns updates for all events.
         * @summary Get updates for events by SSE
         * @param {EventsApiGetEventsUpdatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsUpdates(requestParameters = {}, options) {
            return localVarFp.getEventsUpdates(requestParameters.locale, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.sportId, requestParameters.tournamentId, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.reloadIdsToSkip, requestParameters.tagIds, requestParameters.tagFilterOperation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventsApiGetEventsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsV2(requestParameters = {}, options) {
            return localVarFp.getEventsV2(requestParameters.locale, requestParameters.sportIds, requestParameters.includeSubsports, requestParameters.tournamentIds, requestParameters.statuses, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.ids, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.providerIds, requestParameters.integrationTypes, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.hasActiveLineOutcomes, requestParameters.hasLineOutcomes, requestParameters.fiql, requestParameters.sort, requestParameters.pageKey, requestParameters.pageKeyDirection, requestParameters.pageSize, requestParameters.withCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of scheduled events based on the provided filters. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.
         * @summary Returns a list of events
         * @param {EventsApiGetScheduledLiveEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledLiveEvents(requestParameters = {}, options) {
            return localVarFp.getScheduledLiveEvents(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.offset, requestParameters.limit, requestParameters.sportId, requestParameters.sportIds, requestParameters.locale, requestParameters.tagIds, requestParameters.tagFilterOperation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of events searched by
         * @param {EventsApiSearchEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents(requestParameters, options) {
            return localVarFp.searchEvents(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     *
     * @summary Returns a Event object
     * @param {EventsApiGetEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEvent(requestParameters, options) {
        return EventsApiFp(this.configuration).getEvent(requestParameters.eventId, requestParameters.locale, requestParameters.withCursor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return counters for events
     * @param {EventsApiGetEventCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventCounters(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).getEventCounters(requestParameters.sportIds, requestParameters.tournamentIds, requestParameters.statuses, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.providerIds, requestParameters.integrationTypes, requestParameters.searchQuery, requestParameters.locale, requestParameters.searchQueryFields, requestParameters.hasActiveLineOutcomes, requestParameters.hasLineOutcomes, requestParameters.aggregateByGeneric, requestParameters.includeSubsports, requestParameters.fiql, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a Event Probabilities object
     * @param {EventsApiGetEventProbabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventProbabilities(requestParameters, options) {
        return EventsApiFp(this.configuration).getEventProbabilities(requestParameters.eventId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get event\'s probabilities updates
     * @param {EventsApiGetEventProbabilitiesUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventProbabilitiesUpdates(requestParameters, options) {
        return EventsApiFp(this.configuration).getEventProbabilitiesUpdates(requestParameters.eventId, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.reloadIdsToSkip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns statistics for an event
     * @param {EventsApiGetEventStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventStatistics(requestParameters, options) {
        return EventsApiFp(this.configuration).getEventStatistics(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is a deprecated endpoint, consider using /v2/events for better functionality and performance  Retrieves a list of events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns only top events.   - `top=false` or omit `top`: Returns all events.
     * @summary Returns a list of events.
     * @param {EventsApiGetEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEvents(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).getEvents(requestParameters.locale, requestParameters.sportId, requestParameters.sportIds, requestParameters.tournamentId, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.ids, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.withCursor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Receive updates for events based on the provided filters. - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns updates for events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns updates for events with at least one of the specified `tag-ids`.  - **Top Events:**   - `top=true`: Returns updates only for top events.   - `top=false` or omit `top`: Returns updates for all events.
     * @summary Get updates for events by SSE
     * @param {EventsApiGetEventsUpdatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventsUpdates(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).getEventsUpdates(requestParameters.locale, requestParameters.cursor, requestParameters.cursorResetPolicy, requestParameters.sportId, requestParameters.tournamentId, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.reloadIdsToSkip, requestParameters.tagIds, requestParameters.tagFilterOperation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventsApiGetEventsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getEventsV2(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).getEventsV2(requestParameters.locale, requestParameters.sportIds, requestParameters.includeSubsports, requestParameters.tournamentIds, requestParameters.statuses, requestParameters.live, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.ids, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.providerIds, requestParameters.integrationTypes, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.hasActiveLineOutcomes, requestParameters.hasLineOutcomes, requestParameters.fiql, requestParameters.sort, requestParameters.pageKey, requestParameters.pageKeyDirection, requestParameters.pageSize, requestParameters.withCursor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a list of scheduled events based on the provided filters. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns events with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns events with at least one of the specified `tag-ids`.
     * @summary Returns a list of events
     * @param {EventsApiGetScheduledLiveEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    getScheduledLiveEvents(requestParameters = {}, options) {
        return EventsApiFp(this.configuration).getScheduledLiveEvents(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.offset, requestParameters.limit, requestParameters.sportId, requestParameters.sportIds, requestParameters.locale, requestParameters.tagIds, requestParameters.tagFilterOperation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of events searched by
     * @param {EventsApiSearchEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    searchEvents(requestParameters, options) {
        return EventsApiFp(this.configuration).searchEvents(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FavoriteEventsApi - axios parameter creator
 * @export
 */
export const FavoriteEventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create new favorite event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavoriteEvent: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('createFavoriteEvent', 'eventId', eventId);
            const localVarPath = `/favorite-events/{event-id}`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is deprecated. Please use the `DELETE /favorite-events` endpoint with the `eventIds` list  for deleting specific favorite events.
         * @summary Delete the favorite event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteFavoriteEvent: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteFavoriteEvent', 'eventId', eventId);
            const localVarPath = `/favorite-events/{event-id}`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes favorite events based on the provided list of `eventIds`.   - If `eventIds` are provided, only those events will be deleted.   - If no `eventIds` are provided or the list is empty, all favorite events will be deleted.
         * @summary Delete favorite events
         * @param {Array<number>} [eventIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteEvents: (eventIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (eventIds) {
                localVarQueryParameter['event-ids'] = eventIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get list of favorite events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteEvents: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/favorite-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FavoriteEventsApi - functional programming interface
 * @export
 */
export const FavoriteEventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FavoriteEventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create new favorite event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavoriteEvent(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createFavoriteEvent(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint is deprecated. Please use the `DELETE /favorite-events` endpoint with the `eventIds` list  for deleting specific favorite events.
         * @summary Delete the favorite event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteFavoriteEvent(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFavoriteEvent(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Deletes favorite events based on the provided list of `eventIds`.   - If `eventIds` are provided, only those events will be deleted.   - If no `eventIds` are provided or the list is empty, all favorite events will be deleted.
         * @summary Delete favorite events
         * @param {Array<number>} [eventIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteEvents(eventIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFavoriteEvents(eventIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get list of favorite events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteEvents(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFavoriteEvents(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FavoriteEventsApi - factory interface
 * @export
 */
export const FavoriteEventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FavoriteEventsApiFp(configuration);
    return {
        /**
         *
         * @summary Create new favorite event
         * @param {FavoriteEventsApiCreateFavoriteEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFavoriteEvent(requestParameters, options) {
            return localVarFp.createFavoriteEvent(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is deprecated. Please use the `DELETE /favorite-events` endpoint with the `eventIds` list  for deleting specific favorite events.
         * @summary Delete the favorite event
         * @param {FavoriteEventsApiDeleteFavoriteEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteFavoriteEvent(requestParameters, options) {
            return localVarFp.deleteFavoriteEvent(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes favorite events based on the provided list of `eventIds`.   - If `eventIds` are provided, only those events will be deleted.   - If no `eventIds` are provided or the list is empty, all favorite events will be deleted.
         * @summary Delete favorite events
         * @param {FavoriteEventsApiDeleteFavoriteEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteEvents(requestParameters = {}, options) {
            return localVarFp.deleteFavoriteEvents(requestParameters.eventIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of favorite events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoriteEvents(options) {
            return localVarFp.getFavoriteEvents(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FavoriteEventsApi - object-oriented interface
 * @export
 * @class FavoriteEventsApi
 * @extends {BaseAPI}
 */
export class FavoriteEventsApi extends BaseAPI {
    /**
     *
     * @summary Create new favorite event
     * @param {FavoriteEventsApiCreateFavoriteEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteEventsApi
     */
    createFavoriteEvent(requestParameters, options) {
        return FavoriteEventsApiFp(this.configuration).createFavoriteEvent(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is deprecated. Please use the `DELETE /favorite-events` endpoint with the `eventIds` list  for deleting specific favorite events.
     * @summary Delete the favorite event
     * @param {FavoriteEventsApiDeleteFavoriteEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FavoriteEventsApi
     */
    deleteFavoriteEvent(requestParameters, options) {
        return FavoriteEventsApiFp(this.configuration).deleteFavoriteEvent(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes favorite events based on the provided list of `eventIds`.   - If `eventIds` are provided, only those events will be deleted.   - If no `eventIds` are provided or the list is empty, all favorite events will be deleted.
     * @summary Delete favorite events
     * @param {FavoriteEventsApiDeleteFavoriteEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteEventsApi
     */
    deleteFavoriteEvents(requestParameters = {}, options) {
        return FavoriteEventsApiFp(this.configuration).deleteFavoriteEvents(requestParameters.eventIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of favorite events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteEventsApi
     */
    getFavoriteEvents(options) {
        return FavoriteEventsApiFp(this.configuration).getFavoriteEvents(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GameVendorSettingsApi - axios parameter creator
 * @export
 */
export const GameVendorSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of game vendor settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVendorSettings: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/game-vendor-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GameVendorSettingsApi - functional programming interface
 * @export
 */
export const GameVendorSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = GameVendorSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of game vendor settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVendorSettings(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGameVendorSettings(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GameVendorSettingsApi - factory interface
 * @export
 */
export const GameVendorSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GameVendorSettingsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of game vendor settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGameVendorSettings(options) {
            return localVarFp.getGameVendorSettings(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GameVendorSettingsApi - object-oriented interface
 * @export
 * @class GameVendorSettingsApi
 * @extends {BaseAPI}
 */
export class GameVendorSettingsApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of game vendor settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GameVendorSettingsApi
     */
    getGameVendorSettings(options) {
        return GameVendorSettingsApiFp(this.configuration).getGameVendorSettings(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LanguagesApi - axios parameter creator
 * @export
 */
export const LanguagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LanguagesApi - functional programming interface
 * @export
 */
export const LanguagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = LanguagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLanguages(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LanguagesApi - factory interface
 * @export
 */
export const LanguagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LanguagesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of languages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguages(options) {
            return localVarFp.getLanguages(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LanguagesApi - object-oriented interface
 * @export
 * @class LanguagesApi
 * @extends {BaseAPI}
 */
export class LanguagesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LanguagesApi
     */
    getLanguages(options) {
        return LanguagesApiFp(this.configuration).getLanguages(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LogosApi - axios parameter creator
 * @export
 */
export const LogosApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of logos
         * @param {LogoEntityType} entityType
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogos: (entityType, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getLogos', 'entityType', entityType);
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getLogos', 'ids', ids);
            const localVarPath = `/logos/{entity-type}`
                .replace(`{${"entity-type"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LogosApi - functional programming interface
 * @export
 */
export const LogosApiFp = function (configuration) {
    const localVarAxiosParamCreator = LogosApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of logos
         * @param {LogoEntityType} entityType
         * @param {Array<number>} ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogos(entityType, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLogos(entityType, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LogosApi - factory interface
 * @export
 */
export const LogosApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LogosApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of logos
         * @param {LogosApiGetLogosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogos(requestParameters, options) {
            return localVarFp.getLogos(requestParameters.entityType, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LogosApi - object-oriented interface
 * @export
 * @class LogosApi
 * @extends {BaseAPI}
 */
export class LogosApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of logos
     * @param {LogosApiGetLogosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogosApi
     */
    getLogos(requestParameters, options) {
        return LogosApiFp(this.configuration).getLogos(requestParameters.entityType, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LoyaltyApi - axios parameter creator
 * @export
 */
export const LoyaltyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {string} accountId account id
         * @param {Array<AppliedCouponStatus>} [applyStatuses]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons: (accountId, applyStatuses, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAppliedCoupons', 'accountId', accountId);
            const localVarPath = `/accounts/{account-id}/coupons`
                .replace(`{${"account-id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (applyStatuses) {
                localVarQueryParameter['apply-statuses'] = applyStatuses;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LoyaltyApi - functional programming interface
 * @export
 */
export const LoyaltyApiFp = function (configuration) {
    const localVarAxiosParamCreator = LoyaltyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {string} accountId account id
         * @param {Array<AppliedCouponStatus>} [applyStatuses]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons(accountId, applyStatuses, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppliedCoupons(accountId, applyStatuses, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LoyaltyApi - factory interface
 * @export
 */
export const LoyaltyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LoyaltyApiFp(configuration);
    return {
        /**
         *
         * @summary Get information about coupons which was sent to apply
         * @param {LoyaltyApiGetAppliedCouponsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedCoupons(requestParameters, options) {
            return localVarFp.getAppliedCoupons(requestParameters.accountId, requestParameters.applyStatuses, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LoyaltyApi - object-oriented interface
 * @export
 * @class LoyaltyApi
 * @extends {BaseAPI}
 */
export class LoyaltyApi extends BaseAPI {
    /**
     *
     * @summary Get information about coupons which was sent to apply
     * @param {LoyaltyApiGetAppliedCouponsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoyaltyApi
     */
    getAppliedCoupons(requestParameters, options) {
        return LoyaltyApiFp(this.configuration).getAppliedCoupons(requestParameters.accountId, requestParameters.applyStatuses, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MarketCategoriesApi - axios parameter creator
 * @export
 */
export const MarketCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMarketCategories: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/market-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MarketCategoriesApi - functional programming interface
 * @export
 */
export const MarketCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MarketCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMarketCategories(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMarketCategories(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MarketCategoriesApi - factory interface
 * @export
 */
export const MarketCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MarketCategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of categories
         * @param {MarketCategoriesApiGetMarketCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMarketCategories(requestParameters = {}, options) {
            return localVarFp.getMarketCategories(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MarketCategoriesApi - object-oriented interface
 * @export
 * @class MarketCategoriesApi
 * @extends {BaseAPI}
 */
export class MarketCategoriesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of categories
     * @param {MarketCategoriesApiGetMarketCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MarketCategoriesApi
     */
    getMarketCategories(requestParameters = {}, options) {
        return MarketCategoriesApiFp(this.configuration).getMarketCategories(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MarketGroupsApi - axios parameter creator
 * @export
 */
export const MarketGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of market groups
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketGroups: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/market-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MarketGroupsApi - functional programming interface
 * @export
 */
export const MarketGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MarketGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of market groups
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketGroups(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMarketGroups(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MarketGroupsApi - factory interface
 * @export
 */
export const MarketGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MarketGroupsApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of market groups
         * @param {MarketGroupsApiGetMarketGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketGroups(requestParameters = {}, options) {
            return localVarFp.getMarketGroups(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MarketGroupsApi - object-oriented interface
 * @export
 * @class MarketGroupsApi
 * @extends {BaseAPI}
 */
export class MarketGroupsApi extends BaseAPI {
    /**
     *
     * @summary Return a list of market groups
     * @param {MarketGroupsApiGetMarketGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketGroupsApi
     */
    getMarketGroups(requestParameters = {}, options) {
        return MarketGroupsApiFp(this.configuration).getMarketGroups(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MarketsApi - axios parameter creator
 * @export
 */
export const MarketsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of markets
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/markets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MarketsApi - functional programming interface
 * @export
 */
export const MarketsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MarketsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of markets
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMarkets(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MarketsApi - factory interface
 * @export
 */
export const MarketsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MarketsApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of markets
         * @param {MarketsApiGetMarketsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(requestParameters = {}, options) {
            return localVarFp.getMarkets(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MarketsApi - object-oriented interface
 * @export
 * @class MarketsApi
 * @extends {BaseAPI}
 */
export class MarketsApi extends BaseAPI {
    /**
     *
     * @summary Return a list of markets
     * @param {MarketsApiGetMarketsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketsApi
     */
    getMarkets(requestParameters = {}, options) {
        return MarketsApiFp(this.configuration).getMarkets(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MatchPhasesApi - axios parameter creator
 * @export
 */
export const MatchPhasesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of match-phases
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchPhases: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getMatchPhases', 'locale', locale);
            const localVarPath = `/match-phases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MatchPhasesApi - functional programming interface
 * @export
 */
export const MatchPhasesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MatchPhasesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of match-phases
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchPhases(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMatchPhases(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MatchPhasesApi - factory interface
 * @export
 */
export const MatchPhasesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MatchPhasesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of match-phases
         * @param {MatchPhasesApiGetMatchPhasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchPhases(requestParameters, options) {
            return localVarFp.getMatchPhases(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MatchPhasesApi - object-oriented interface
 * @export
 * @class MatchPhasesApi
 * @extends {BaseAPI}
 */
export class MatchPhasesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of match-phases
     * @param {MatchPhasesApiGetMatchPhasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchPhasesApi
     */
    getMatchPhases(requestParameters, options) {
        return MatchPhasesApiFp(this.configuration).getMatchPhases(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a message
         * @param {string} messageId Identifier of message
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: (messageId, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessage', 'messageId', messageId);
            const localVarPath = `/messages/{message-id}`
                .replace(`{${"message-id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a count of messages of current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/messages/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get list of messages
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [from]
         * @param {string} [to]
         * @param {boolean} [direct]
         * @param {boolean} [read]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageList: (offset, limit, from, to, direct, read, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (direct !== undefined) {
                localVarQueryParameter['direct'] = direct;
            }
            if (read !== undefined) {
                localVarQueryParameter['read'] = read;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Mark message as read
         * @param {string} messageId Identifier of message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead: (messageId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('markAsRead', 'messageId', messageId);
            const localVarPath = `/messages/{message-id}`
                .replace(`{${"message-id"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Read all messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessages: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a message
         * @param {string} messageId Identifier of message
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage(messageId, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessage(messageId, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a count of messages of current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessageCount(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get list of messages
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [from]
         * @param {string} [to]
         * @param {boolean} [direct]
         * @param {boolean} [read]
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageList(offset, limit, from, to, direct, read, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessageList(offset, limit, from, to, direct, read, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Mark message as read
         * @param {string} messageId Identifier of message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(messageId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markAsRead(messageId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Read all messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessages(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.readAllMessages(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MessagesApiFp(configuration);
    return {
        /**
         *
         * @summary Get a message
         * @param {MessagesApiGetMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage(requestParameters, options) {
            return localVarFp.getMessage(requestParameters.messageId, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a count of messages of current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCount(options) {
            return localVarFp.getMessageCount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get list of messages
         * @param {MessagesApiGetMessageListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageList(requestParameters = {}, options) {
            return localVarFp.getMessageList(requestParameters.offset, requestParameters.limit, requestParameters.from, requestParameters.to, requestParameters.direct, requestParameters.read, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark message as read
         * @param {MessagesApiMarkAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRead(requestParameters, options) {
            return localVarFp.markAsRead(requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Read all messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAllMessages(options) {
            return localVarFp.readAllMessages(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     *
     * @summary Get a message
     * @param {MessagesApiGetMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    getMessage(requestParameters, options) {
        return MessagesApiFp(this.configuration).getMessage(requestParameters.messageId, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a count of messages of current client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    getMessageCount(options) {
        return MessagesApiFp(this.configuration).getMessageCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get list of messages
     * @param {MessagesApiGetMessageListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    getMessageList(requestParameters = {}, options) {
        return MessagesApiFp(this.configuration).getMessageList(requestParameters.offset, requestParameters.limit, requestParameters.from, requestParameters.to, requestParameters.direct, requestParameters.read, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark message as read
     * @param {MessagesApiMarkAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    markAsRead(requestParameters, options) {
        return MessagesApiFp(this.configuration).markAsRead(requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Read all messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    readAllMessages(options) {
        return MessagesApiFp(this.configuration).readAllMessages(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OutcomeCategoriesApi - axios parameter creator
 * @export
 */
export const OutcomeCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of outcome categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeCategories: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/outcome-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OutcomeCategoriesApi - functional programming interface
 * @export
 */
export const OutcomeCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = OutcomeCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of outcome categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeCategories(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOutcomeCategories(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OutcomeCategoriesApi - factory interface
 * @export
 */
export const OutcomeCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OutcomeCategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of outcome categories
         * @param {OutcomeCategoriesApiGetOutcomeCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomeCategories(requestParameters = {}, options) {
            return localVarFp.getOutcomeCategories(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OutcomeCategoriesApi - object-oriented interface
 * @export
 * @class OutcomeCategoriesApi
 * @extends {BaseAPI}
 */
export class OutcomeCategoriesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of outcome categories
     * @param {OutcomeCategoriesApiGetOutcomeCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeCategoriesApi
     */
    getOutcomeCategories(requestParameters = {}, options) {
        return OutcomeCategoriesApiFp(this.configuration).getOutcomeCategories(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OutcomesApi - axios parameter creator
 * @export
 */
export const OutcomesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return outcomes list by id
         * @param {Array<string>} outcomeIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomes: (outcomeIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'outcomeIds' is not null or undefined
            assertParamExists('getOutcomes', 'outcomeIds', outcomeIds);
            const localVarPath = `/outcomes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (outcomeIds) {
                localVarQueryParameter['outcome-ids'] = outcomeIds.join(COLLECTION_FORMATS.csv);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OutcomesApi - functional programming interface
 * @export
 */
export const OutcomesApiFp = function (configuration) {
    const localVarAxiosParamCreator = OutcomesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return outcomes list by id
         * @param {Array<string>} outcomeIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomes(outcomeIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOutcomes(outcomeIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OutcomesApi - factory interface
 * @export
 */
export const OutcomesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OutcomesApiFp(configuration);
    return {
        /**
         *
         * @summary Return outcomes list by id
         * @param {OutcomesApiGetOutcomesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutcomes(requestParameters, options) {
            return localVarFp.getOutcomes(requestParameters.outcomeIds, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OutcomesApi - object-oriented interface
 * @export
 * @class OutcomesApi
 * @extends {BaseAPI}
 */
export class OutcomesApi extends BaseAPI {
    /**
     *
     * @summary Return outcomes list by id
     * @param {OutcomesApiGetOutcomesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomesApi
     */
    getOutcomes(requestParameters, options) {
        return OutcomesApiFp(this.configuration).getOutcomes(requestParameters.outcomeIds, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PagesApi - axios parameter creator
 * @export
 */
export const PagesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPages: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PagesApi - functional programming interface
 * @export
 */
export const PagesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PagesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPages(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPages(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PagesApi - factory interface
 * @export
 */
export const PagesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PagesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of pages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPages(options) {
            return localVarFp.getPages(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PagesApi - object-oriented interface
 * @export
 * @class PagesApi
 * @extends {BaseAPI}
 */
export class PagesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of pages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PagesApi
     */
    getPages(options) {
        return PagesApiFp(this.configuration).getPages(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PaymentMethodGroupsApi - axios parameter creator
 * @export
 */
export const PaymentMethodGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of payment method groups
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodGroups: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payment-method-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentMethodGroupsApi - functional programming interface
 * @export
 */
export const PaymentMethodGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentMethodGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of payment method groups
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodGroups(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentMethodGroups(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentMethodGroupsApi - factory interface
 * @export
 */
export const PaymentMethodGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentMethodGroupsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of payment method groups
         * @param {PaymentMethodGroupsApiGetPaymentMethodGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethodGroups(requestParameters = {}, options) {
            return localVarFp.getPaymentMethodGroups(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentMethodGroupsApi - object-oriented interface
 * @export
 * @class PaymentMethodGroupsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodGroupsApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of payment method groups
     * @param {PaymentMethodGroupsApiGetPaymentMethodGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodGroupsApi
     */
    getPaymentMethodGroups(requestParameters = {}, options) {
        return PaymentMethodGroupsApiFp(this.configuration).getPaymentMethodGroups(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Creates a web payment transaction.
         * @param {string} [locale] Needed for localization of constraint reasons
         * @param {NewWebPayment} [newWebPayment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebPayment: (locale, newWebPayment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newWebPayment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of payment accounts.
         * @param {string} accountId
         * @param {number} methodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentAccounts: (accountId, methodId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getPaymentAccounts', 'accountId', accountId);
            // verify required parameter 'methodId' is not null or undefined
            assertParamExists('getPaymentAccounts', 'methodId', methodId);
            const localVarPath = `/payments/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (methodId !== undefined) {
                localVarQueryParameter['method-id'] = methodId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of payment fees.
         * @param {string} accountId
         * @param {number} providerId
         * @param {Array<number>} methodIds
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees: (accountId, providerId, methodIds, amount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getPaymentFees', 'accountId', accountId);
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getPaymentFees', 'providerId', providerId);
            // verify required parameter 'methodIds' is not null or undefined
            assertParamExists('getPaymentFees', 'methodIds', methodIds);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getPaymentFees', 'amount', amount);
            const localVarPath = `/payments/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider-id'] = providerId;
            }
            if (methodIds) {
                localVarQueryParameter['method-ids'] = methodIds;
            }
            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of payment methods.
         * @param {string} [locale]
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: (locale, accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payments/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of payment transactions for a current client.
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [accountId]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [sourceId]
         * @param {number} [currencyId]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<PaymentStatus>} [statuses]
         * @param {number} [methodId]
         * @param {number} [providerId]
         * @param {Array<string>} [ids] List of ids
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments: (offset, limit, accountId, from, to, sourceId, currencyId, minAmount, maxAmount, statuses, methodId, providerId, ids, order, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (sourceId !== undefined) {
                localVarQueryParameter['source-id'] = sourceId;
            }
            if (currencyId !== undefined) {
                localVarQueryParameter['currency-id'] = currencyId;
            }
            if (minAmount !== undefined) {
                localVarQueryParameter['min-amount'] = minAmount;
            }
            if (maxAmount !== undefined) {
                localVarQueryParameter['max-amount'] = maxAmount;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (methodId !== undefined) {
                localVarQueryParameter['method-id'] = methodId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider-id'] = providerId;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Creates a web payment transaction.
         * @param {string} [locale] Needed for localization of constraint reasons
         * @param {NewWebPayment} [newWebPayment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebPayment(locale, newWebPayment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWebPayment(locale, newWebPayment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of payment accounts.
         * @param {string} accountId
         * @param {number} methodId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentAccounts(accountId, methodId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentAccounts(accountId, methodId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of payment fees.
         * @param {string} accountId
         * @param {number} providerId
         * @param {Array<number>} methodIds
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees(accountId, providerId, methodIds, amount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentFees(accountId, providerId, methodIds, amount, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of payment methods.
         * @param {string} [locale]
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(locale, accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPaymentMethods(locale, accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of payment transactions for a current client.
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [accountId]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [sourceId]
         * @param {number} [currencyId]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<PaymentStatus>} [statuses]
         * @param {number} [methodId]
         * @param {number} [providerId]
         * @param {Array<string>} [ids] List of ids
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(offset, limit, accountId, from, to, sourceId, currencyId, minAmount, maxAmount, statuses, methodId, providerId, ids, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayments(offset, limit, accountId, from, to, sourceId, currencyId, minAmount, maxAmount, statuses, methodId, providerId, ids, order, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentsApiFp(configuration);
    return {
        /**
         *
         * @summary Creates a web payment transaction.
         * @param {PaymentsApiCreateWebPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWebPayment(requestParameters = {}, options) {
            return localVarFp.createWebPayment(requestParameters.locale, requestParameters.newWebPayment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of payment accounts.
         * @param {PaymentsApiGetPaymentAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentAccounts(requestParameters, options) {
            return localVarFp.getPaymentAccounts(requestParameters.accountId, requestParameters.methodId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of payment fees.
         * @param {PaymentsApiGetPaymentFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentFees(requestParameters, options) {
            return localVarFp.getPaymentFees(requestParameters.accountId, requestParameters.providerId, requestParameters.methodIds, requestParameters.amount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of payment methods.
         * @param {PaymentsApiGetPaymentMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(requestParameters = {}, options) {
            return localVarFp.getPaymentMethods(requestParameters.locale, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of payment transactions for a current client.
         * @param {PaymentsApiGetPaymentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayments(requestParameters = {}, options) {
            return localVarFp.getPayments(requestParameters.offset, requestParameters.limit, requestParameters.accountId, requestParameters.from, requestParameters.to, requestParameters.sourceId, requestParameters.currencyId, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.statuses, requestParameters.methodId, requestParameters.providerId, requestParameters.ids, requestParameters.order, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     *
     * @summary Creates a web payment transaction.
     * @param {PaymentsApiCreateWebPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    createWebPayment(requestParameters = {}, options) {
        return PaymentsApiFp(this.configuration).createWebPayment(requestParameters.locale, requestParameters.newWebPayment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of payment accounts.
     * @param {PaymentsApiGetPaymentAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentAccounts(requestParameters, options) {
        return PaymentsApiFp(this.configuration).getPaymentAccounts(requestParameters.accountId, requestParameters.methodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of payment fees.
     * @param {PaymentsApiGetPaymentFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentFees(requestParameters, options) {
        return PaymentsApiFp(this.configuration).getPaymentFees(requestParameters.accountId, requestParameters.providerId, requestParameters.methodIds, requestParameters.amount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of payment methods.
     * @param {PaymentsApiGetPaymentMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPaymentMethods(requestParameters = {}, options) {
        return PaymentsApiFp(this.configuration).getPaymentMethods(requestParameters.locale, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of payment transactions for a current client.
     * @param {PaymentsApiGetPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    getPayments(requestParameters = {}, options) {
        return PaymentsApiFp(this.configuration).getPayments(requestParameters.offset, requestParameters.limit, requestParameters.accountId, requestParameters.from, requestParameters.to, requestParameters.sourceId, requestParameters.currencyId, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.statuses, requestParameters.methodId, requestParameters.providerId, requestParameters.ids, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlayersApi - axios parameter creator
 * @export
 */
export const PlayersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of players.
         * @param {Array<number>} ids
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers: (ids, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getPlayers', 'ids', ids);
            const localVarPath = `/players`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PlayersApi - functional programming interface
 * @export
 */
export const PlayersApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlayersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of players.
         * @param {Array<number>} ids
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers(ids, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlayers(ids, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PlayersApi - factory interface
 * @export
 */
export const PlayersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlayersApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of players.
         * @param {PlayersApiGetPlayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlayers(requestParameters, options) {
            return localVarFp.getPlayers(requestParameters.ids, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlayersApi - object-oriented interface
 * @export
 * @class PlayersApi
 * @extends {BaseAPI}
 */
export class PlayersApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of players.
     * @param {PlayersApiGetPlayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayersApi
     */
    getPlayers(requestParameters, options) {
        return PlayersApiFp(this.configuration).getPlayers(requestParameters.ids, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProfilesApi - axios parameter creator
 * @export
 */
export const ProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentClient: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns current client info.
         * @param {string} [locale] Needed for localization of constraints reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClient: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns current client settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClientSettings: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update current client
         * @param {string} [locale] Needed for localization of constraints reasons
         * @param {ClientUpdate} [clientUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClient: (locale, clientUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clientUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update current client\'s password
         * @param {ClientPasswordUpdate} [clientPasswordUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientPassword: (clientPasswordUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clientPasswordUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update current client settings
         * @param {ClientSettingsUpdate} [clientSettingsUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientSettings: (clientSettingsUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles/current/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clientSettingsUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProfilesApi - functional programming interface
 * @export
 */
export const ProfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentClient(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCurrentClient(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns current client info.
         * @param {string} [locale] Needed for localization of constraints reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClient(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentClient(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns current client settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClientSettings(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentClientSettings(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update current client
         * @param {string} [locale] Needed for localization of constraints reasons
         * @param {ClientUpdate} [clientUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClient(locale, clientUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCurrentClient(locale, clientUpdate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update current client\'s password
         * @param {ClientPasswordUpdate} [clientPasswordUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientPassword(clientPasswordUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCurrentClientPassword(clientPasswordUpdate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update current client settings
         * @param {ClientSettingsUpdate} [clientSettingsUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientSettings(clientSettingsUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCurrentClientSettings(clientSettingsUpdate, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProfilesApi - factory interface
 * @export
 */
export const ProfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfilesApiFp(configuration);
    return {
        /**
         *
         * @summary Delete current client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentClient(options) {
            return localVarFp.deleteCurrentClient(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns current client info.
         * @param {ProfilesApiGetCurrentClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClient(requestParameters = {}, options) {
            return localVarFp.getCurrentClient(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns current client settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentClientSettings(options) {
            return localVarFp.getCurrentClientSettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update current client
         * @param {ProfilesApiUpdateCurrentClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClient(requestParameters = {}, options) {
            return localVarFp.updateCurrentClient(requestParameters.locale, requestParameters.clientUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update current client\'s password
         * @param {ProfilesApiUpdateCurrentClientPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientPassword(requestParameters = {}, options) {
            return localVarFp.updateCurrentClientPassword(requestParameters.clientPasswordUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update current client settings
         * @param {ProfilesApiUpdateCurrentClientSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentClientSettings(requestParameters = {}, options) {
            return localVarFp.updateCurrentClientSettings(requestParameters.clientSettingsUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProfilesApi - object-oriented interface
 * @export
 * @class ProfilesApi
 * @extends {BaseAPI}
 */
export class ProfilesApi extends BaseAPI {
    /**
     *
     * @summary Delete current client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    deleteCurrentClient(options) {
        return ProfilesApiFp(this.configuration).deleteCurrentClient(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns current client info.
     * @param {ProfilesApiGetCurrentClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    getCurrentClient(requestParameters = {}, options) {
        return ProfilesApiFp(this.configuration).getCurrentClient(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns current client settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    getCurrentClientSettings(options) {
        return ProfilesApiFp(this.configuration).getCurrentClientSettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update current client
     * @param {ProfilesApiUpdateCurrentClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    updateCurrentClient(requestParameters = {}, options) {
        return ProfilesApiFp(this.configuration).updateCurrentClient(requestParameters.locale, requestParameters.clientUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update current client\'s password
     * @param {ProfilesApiUpdateCurrentClientPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    updateCurrentClientPassword(requestParameters = {}, options) {
        return ProfilesApiFp(this.configuration).updateCurrentClientPassword(requestParameters.clientPasswordUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update current client settings
     * @param {ProfilesApiUpdateCurrentClientSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    updateCurrentClientSettings(requestParameters = {}, options) {
        return ProfilesApiFp(this.configuration).updateCurrentClientSettings(requestParameters.clientSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of entities
         * @param {string} query
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEntities: (query, locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchEntities', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('searchEntities', 'locale', locale);
            const localVarPath = `/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of events searched by
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents: (query, locale, sportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchEvents', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('searchEvents', 'locale', locale);
            const localVarPath = `/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments: (query, locale, sportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchTournaments', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('searchTournaments', 'locale', locale);
            const localVarPath = `/tournaments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of entities
         * @param {string} query
         * @param {string} locale
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEntities(query, locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchEntities(query, locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of events searched by
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents(query, locale, sportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchEvents(query, locale, sportId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments(query, locale, sportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTournaments(query, locale, sportId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of entities
         * @param {SearchApiSearchEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEntities(requestParameters, options) {
            return localVarFp.searchEntities(requestParameters.query, requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of events searched by
         * @param {SearchApiSearchEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchEvents(requestParameters, options) {
            return localVarFp.searchEvents(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {SearchApiSearchTournamentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments(requestParameters, options) {
            return localVarFp.searchTournaments(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     *
     * @summary Return a list of entities
     * @param {SearchApiSearchEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    searchEntities(requestParameters, options) {
        return SearchApiFp(this.configuration).searchEntities(requestParameters.query, requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of events searched by
     * @param {SearchApiSearchEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    searchEvents(requestParameters, options) {
        return SearchApiFp(this.configuration).searchEvents(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of tournaments searched by query
     * @param {SearchApiSearchTournamentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    searchTournaments(requestParameters, options) {
        return SearchApiFp(this.configuration).searchTournaments(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SportsApi - axios parameter creator
 * @export
 */
export const SportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of sports.
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSports: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get entities updates by sportId
         * @param {number} sportId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUpdatesBySportId: (sportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sportId' is not null or undefined
            assertParamExists('getUpdatesBySportId', 'sportId', sportId);
            const localVarPath = `/sports/{sport-id}/updates`
                .replace(`{${"sport-id"}}`, encodeURIComponent(String(sportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SportsApi - functional programming interface
 * @export
 */
export const SportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of sports.
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSports(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSports(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get entities updates by sportId
         * @param {number} sportId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUpdatesBySportId(sportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUpdatesBySportId(sportId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SportsApi - factory interface
 * @export
 */
export const SportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SportsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of sports.
         * @param {SportsApiGetSportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSports(requestParameters = {}, options) {
            return localVarFp.getSports(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get entities updates by sportId
         * @param {SportsApiGetUpdatesBySportIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getUpdatesBySportId(requestParameters, options) {
            return localVarFp.getUpdatesBySportId(requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SportsApi - object-oriented interface
 * @export
 * @class SportsApi
 * @extends {BaseAPI}
 */
export class SportsApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of sports.
     * @param {SportsApiGetSportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SportsApi
     */
    getSports(requestParameters = {}, options) {
        return SportsApiFp(this.configuration).getSports(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get entities updates by sportId
     * @param {SportsApiGetUpdatesBySportIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SportsApi
     */
    getUpdatesBySportId(requestParameters, options) {
        return SportsApiFp(this.configuration).getUpdatesBySportId(requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SportsCountersApi - axios parameter creator
 * @export
 */
export const SportsCountersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of line sports counters
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLineSportsCounters: (scheduledFrom, scheduledTo, aggregateByGeneric, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sports-counters/line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of live sports counters
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLiveSportsCounters: (aggregateByGeneric, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sports-counters/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of results sports counters
         * @param {string} date
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getResultSportsCounters: (date, aggregateByGeneric, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getResultSportsCounters', 'date', date);
            const localVarPath = `/sports-counters/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of results sports counters
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledSportsCounters: (scheduledFrom, scheduledTo, aggregateByGeneric, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sports-counters/scheduled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (aggregateByGeneric !== undefined) {
                localVarQueryParameter['aggregate-by-generic'] = aggregateByGeneric;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SportsCountersApi - functional programming interface
 * @export
 */
export const SportsCountersApiFp = function (configuration) {
    const localVarAxiosParamCreator = SportsCountersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of line sports counters
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLineSportsCounters(scheduledFrom, scheduledTo, aggregateByGeneric, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLineSportsCounters(scheduledFrom, scheduledTo, aggregateByGeneric, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of live sports counters
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLiveSportsCounters(aggregateByGeneric, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLiveSportsCounters(aggregateByGeneric, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of results sports counters
         * @param {string} date
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getResultSportsCounters(date, aggregateByGeneric, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getResultSportsCounters(date, aggregateByGeneric, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of results sports counters
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [aggregateByGeneric]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledSportsCounters(scheduledFrom, scheduledTo, aggregateByGeneric, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getScheduledSportsCounters(scheduledFrom, scheduledTo, aggregateByGeneric, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SportsCountersApi - factory interface
 * @export
 */
export const SportsCountersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SportsCountersApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of line sports counters
         * @param {SportsCountersApiGetLineSportsCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLineSportsCounters(requestParameters = {}, options) {
            return localVarFp.getLineSportsCounters(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.aggregateByGeneric, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of live sports counters
         * @param {SportsCountersApiGetLiveSportsCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getLiveSportsCounters(requestParameters = {}, options) {
            return localVarFp.getLiveSportsCounters(requestParameters.aggregateByGeneric, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of results sports counters
         * @param {SportsCountersApiGetResultSportsCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getResultSportsCounters(requestParameters, options) {
            return localVarFp.getResultSportsCounters(requestParameters.date, requestParameters.aggregateByGeneric, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of results sports counters
         * @param {SportsCountersApiGetScheduledSportsCountersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getScheduledSportsCounters(requestParameters = {}, options) {
            return localVarFp.getScheduledSportsCounters(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.aggregateByGeneric, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SportsCountersApi - object-oriented interface
 * @export
 * @class SportsCountersApi
 * @extends {BaseAPI}
 */
export class SportsCountersApi extends BaseAPI {
    /**
     *
     * @summary Return a list of line sports counters
     * @param {SportsCountersApiGetLineSportsCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SportsCountersApi
     */
    getLineSportsCounters(requestParameters = {}, options) {
        return SportsCountersApiFp(this.configuration).getLineSportsCounters(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.aggregateByGeneric, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of live sports counters
     * @param {SportsCountersApiGetLiveSportsCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SportsCountersApi
     */
    getLiveSportsCounters(requestParameters = {}, options) {
        return SportsCountersApiFp(this.configuration).getLiveSportsCounters(requestParameters.aggregateByGeneric, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of results sports counters
     * @param {SportsCountersApiGetResultSportsCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SportsCountersApi
     */
    getResultSportsCounters(requestParameters, options) {
        return SportsCountersApiFp(this.configuration).getResultSportsCounters(requestParameters.date, requestParameters.aggregateByGeneric, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of results sports counters
     * @param {SportsCountersApiGetScheduledSportsCountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SportsCountersApi
     */
    getScheduledSportsCounters(requestParameters = {}, options) {
        return SportsCountersApiFp(this.configuration).getScheduledSportsCounters(requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.aggregateByGeneric, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns statistics for an event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEventStatistics', 'eventId', eventId);
            const localVarPath = `/events/{event-id}/statistics`
                .replace(`{${"event-id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns statistics for an event
         * @param {number} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEventStatistics(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StatisticsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns statistics for an event
         * @param {StatisticsApiGetEventStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventStatistics(requestParameters, options) {
            return localVarFp.getEventStatistics(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     *
     * @summary Returns statistics for an event
     * @param {StatisticsApiGetEventStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    getEventStatistics(requestParameters, options) {
        return StatisticsApiFp(this.configuration).getEventStatistics(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SystemCurrenciesApi - axios parameter creator
 * @export
 */
export const SystemCurrenciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns a list of system currencies
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemCurrencies: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/system-currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SystemCurrenciesApi - functional programming interface
 * @export
 */
export const SystemCurrenciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = SystemCurrenciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns a list of system currencies
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemCurrencies(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSystemCurrencies(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SystemCurrenciesApi - factory interface
 * @export
 */
export const SystemCurrenciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SystemCurrenciesApiFp(configuration);
    return {
        /**
         *
         * @summary Returns a list of system currencies
         * @param {SystemCurrenciesApiGetSystemCurrenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemCurrencies(requestParameters = {}, options) {
            return localVarFp.getSystemCurrencies(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SystemCurrenciesApi - object-oriented interface
 * @export
 * @class SystemCurrenciesApi
 * @extends {BaseAPI}
 */
export class SystemCurrenciesApi extends BaseAPI {
    /**
     *
     * @summary Returns a list of system currencies
     * @param {SystemCurrenciesApiGetSystemCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemCurrenciesApi
     */
    getSystemCurrencies(requestParameters = {}, options) {
        return SystemCurrenciesApiFp(this.configuration).getSystemCurrencies(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get tag by code
         * @param {string} tagCode Identifier of tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagByCode: (tagCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagCode' is not null or undefined
            assertParamExists('getTagByCode', 'tagCode', tagCode);
            const localVarPath = `/tags/{tag-code}`
                .replace(`{${"tag-code"}}`, encodeURIComponent(String(tagCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get tag list
         * @param {TagRelated} [related]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: (related, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (related !== undefined) {
                localVarQueryParameter['related'] = related;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get tag by code
         * @param {string} tagCode Identifier of tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagByCode(tagCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTagByCode(tagCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get tag list
         * @param {TagRelated} [related]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(related, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTags(related, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TagsApiFp(configuration);
    return {
        /**
         *
         * @summary Get tag by code
         * @param {TagsApiGetTagByCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagByCode(requestParameters, options) {
            return localVarFp.getTagByCode(requestParameters.tagCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get tag list
         * @param {TagsApiGetTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(requestParameters = {}, options) {
            return localVarFp.getTags(requestParameters.related, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
    /**
     *
     * @summary Get tag by code
     * @param {TagsApiGetTagByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    getTagByCode(requestParameters, options) {
        return TagsApiFp(this.configuration).getTagByCode(requestParameters.tagCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get tag list
     * @param {TagsApiGetTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    getTags(requestParameters = {}, options) {
        return TagsApiFp(this.configuration).getTags(requestParameters.related, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TournamentsApi - axios parameter creator
 * @export
 */
export const TournamentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieves a list of tournaments based on the provided filters. - **Tournaments by ids:**   - Returns all tournaments with specified ids. If this parameter is defined other parameters must be empty  - **All Tournaments by Sport:**     - Returns tournaments for the specified `sport-id`.  - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns tournaments with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns tournaments with at least one of the specified `tag-ids`.  - **Top Tournaments:**   - `top=true`: Returns only top tournaments.   - `top=false` or omit `top`: Returns all tournaments.
         * @summary Returns a list of tournaments.
         * @param {Array<number>} [ids]
         * @param {string} [locale]
         * @param {number} [sportId]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {boolean} [includeSubsports]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {EventLiveliness} [eventLiveliness] Filter tournaments by presence of LIVE/LINE/ALL events linked to the tournament. If parameter is missing the LINE value will be used by default
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTournaments: (ids, locale, sportId, scheduledFrom, scheduledTo, top, includeSubsports, tagIds, tagFilterOperation, eventLiveliness, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (tagIds) {
                localVarQueryParameter['tag-ids'] = tagIds;
            }
            if (tagFilterOperation !== undefined) {
                localVarQueryParameter['tag-filter-operation'] = tagFilterOperation;
            }
            if (eventLiveliness !== undefined) {
                localVarQueryParameter['event-liveliness'] = eventLiveliness;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of tournaments that has at least one corresponding event that matches all filters
         * @summary Returns a list of tournaments.
         * @param {Array<number>} [ids] Filter by tournament IDs.  Note: This filter does not work with other filters. If both IDs and any other filters are provided, a validation error will be thrown.
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [countryIds]
         * @param {string} [scheduledFrom] Search for tournaments by presence of events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for tournaments by presence of events that are scheduled at or before the specified date and time.
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, tournaments of both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentTagIds]
         * @param {TagFilterOperation} [tournamentTagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an tournament. For example,  if there is tournament1 with tags [1, 3, 6] and tournament2 with [2, 3, 5], and you search for  tag IDs [1, 2] with LOOSE, you will get both tournament1 and tournament2. However, when you search for [1, 3] with STRICT, only tournament1 will be returned. Note: The default value is LOOSE.
         * @param {boolean} [eventLiveliness] Filter tournaments based on the live status of associated events
         * @param {Array<ActiveEventStatus>} [eventStatuses]
         * @param {Array<string>} [providerIds] Mistakenly added filter
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;groupOrder.asc\&quot;, \&quot;tournamentName.desc\&quot;] - [\&quot;tournamentWeight.topCyber.asc\&quot;, \&quot;tournamentName.desc\&quot;] **Sort fields** for tournaments are:   - tournamentName   - sportOrder   - groupOrder   - tournamentTagOrder  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {number} [pageSize]
         * @param {string} [searchQuery] Search by substring
         * @param {Array<SearchQueryField>} [searchQueryFields] Specifies the event fields that are used for search by search-query. If empty or null and search-query is  specified then uses ALL as default Only tournaments having events matching the filter will be returned
         * @param {boolean} [eventHasLineOutcomes] If set to true then tournaments with only Line events without outcomes will be excluded from response. If set to false will do nothing Default is true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsV2: (ids, locale, sportIds, countryIds, scheduledFrom, scheduledTo, includeSubsports, tournamentTagIds, tournamentTagFilterOperation, eventLiveliness, eventStatuses, providerIds, sort, pageKey, pageSize, searchQuery, searchQueryFields, eventHasLineOutcomes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/tournaments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (sportIds) {
                localVarQueryParameter['sport-ids'] = sportIds;
            }
            if (countryIds) {
                localVarQueryParameter['country-ids'] = countryIds;
            }
            if (scheduledFrom !== undefined) {
                localVarQueryParameter['scheduled-from'] = (scheduledFrom instanceof Date) ?
                    scheduledFrom.toISOString() :
                    scheduledFrom;
            }
            if (scheduledTo !== undefined) {
                localVarQueryParameter['scheduled-to'] = (scheduledTo instanceof Date) ?
                    scheduledTo.toISOString() :
                    scheduledTo;
            }
            if (includeSubsports !== undefined) {
                localVarQueryParameter['include-subsports'] = includeSubsports;
            }
            if (tournamentTagIds) {
                localVarQueryParameter['tournament-tag-ids'] = tournamentTagIds;
            }
            if (tournamentTagFilterOperation !== undefined) {
                localVarQueryParameter['tournament-tag-filter-operation'] = tournamentTagFilterOperation;
            }
            if (eventLiveliness !== undefined) {
                localVarQueryParameter['event-liveliness'] = eventLiveliness;
            }
            if (eventStatuses) {
                localVarQueryParameter['event-statuses'] = eventStatuses;
            }
            if (providerIds) {
                localVarQueryParameter['provider-ids'] = providerIds;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            if (pageKey !== undefined) {
                localVarQueryParameter['page-key'] = pageKey;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page-size'] = pageSize;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['search-query'] = searchQuery;
            }
            if (searchQueryFields) {
                localVarQueryParameter['search-query-fields'] = searchQueryFields;
            }
            if (eventHasLineOutcomes !== undefined) {
                localVarQueryParameter['event-has-line-outcomes'] = eventHasLineOutcomes;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments: (query, locale, sportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchTournaments', 'query', query);
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('searchTournaments', 'locale', locale);
            const localVarPath = `/tournaments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (sportId !== undefined) {
                localVarQueryParameter['sport-id'] = sportId;
            }
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TournamentsApi - functional programming interface
 * @export
 */
export const TournamentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TournamentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieves a list of tournaments based on the provided filters. - **Tournaments by ids:**   - Returns all tournaments with specified ids. If this parameter is defined other parameters must be empty  - **All Tournaments by Sport:**     - Returns tournaments for the specified `sport-id`.  - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns tournaments with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns tournaments with at least one of the specified `tag-ids`.  - **Top Tournaments:**   - `top=true`: Returns only top tournaments.   - `top=false` or omit `top`: Returns all tournaments.
         * @summary Returns a list of tournaments.
         * @param {Array<number>} [ids]
         * @param {string} [locale]
         * @param {number} [sportId]
         * @param {string} [scheduledFrom]
         * @param {string} [scheduledTo]
         * @param {boolean} [top]
         * @param {boolean} [includeSubsports]
         * @param {Array<number>} [tagIds]
         * @param {TagFilterOperation} [tagFilterOperation]
         * @param {EventLiveliness} [eventLiveliness] Filter tournaments by presence of LIVE/LINE/ALL events linked to the tournament. If parameter is missing the LINE value will be used by default
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTournaments(ids, locale, sportId, scheduledFrom, scheduledTo, top, includeSubsports, tagIds, tagFilterOperation, eventLiveliness, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournaments(ids, locale, sportId, scheduledFrom, scheduledTo, top, includeSubsports, tagIds, tagFilterOperation, eventLiveliness, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Get list of tournaments that has at least one corresponding event that matches all filters
         * @summary Returns a list of tournaments.
         * @param {Array<number>} [ids] Filter by tournament IDs.  Note: This filter does not work with other filters. If both IDs and any other filters are provided, a validation error will be thrown.
         * @param {string} [locale] Specifies locale for output and for search queries
         * @param {Array<number>} [sportIds]
         * @param {Array<number>} [countryIds]
         * @param {string} [scheduledFrom] Search for tournaments by presence of events that are scheduled at or after the specified date and time.
         * @param {string} [scheduledTo] Search for tournaments by presence of events that are scheduled at or before the specified date and time.
         * @param {boolean} [includeSubsports] Set to filter by generic sport IDs as well. For example, if there is a CyberSport (id&#x3D;105) that is  generic for Dota2 (id&#x3D;1005), and sport-ids&#x3D;[105] are requested, tournaments of both CyberSport and Dota2  will be returned.
         * @param {Array<number>} [tournamentTagIds]
         * @param {TagFilterOperation} [tournamentTagFilterOperation] Specifies whether all (STRICT) or any (LOOSE) tag IDs should be assigned to an tournament. For example,  if there is tournament1 with tags [1, 3, 6] and tournament2 with [2, 3, 5], and you search for  tag IDs [1, 2] with LOOSE, you will get both tournament1 and tournament2. However, when you search for [1, 3] with STRICT, only tournament1 will be returned. Note: The default value is LOOSE.
         * @param {boolean} [eventLiveliness] Filter tournaments based on the live status of associated events
         * @param {Array<ActiveEventStatus>} [eventStatuses]
         * @param {Array<string>} [providerIds] Mistakenly added filter
         * @param {Array<string>} [sort] Sorting criteria array. Each element follows the pattern: - \&#39;{sort_field}.{direction}\&#39; where direction is \&#39;asc\&#39; or \&#39;desc\&#39; - For weight categories:    \&#39;tournamentWeight.{weight_category_system_code}.{direction}\&#39;  Examples: - [\&quot;groupOrder.asc\&quot;, \&quot;tournamentName.desc\&quot;] - [\&quot;tournamentWeight.topCyber.asc\&quot;, \&quot;tournamentName.desc\&quot;] **Sort fields** for tournaments are:   - tournamentName   - sportOrder   - groupOrder   - tournamentTagOrder  Note: \&#39;id.desc\&#39; is always appended for tie-breaking
         * @param {string} [pageKey] Pagination key
         * @param {number} [pageSize]
         * @param {string} [searchQuery] Search by substring
         * @param {Array<SearchQueryField>} [searchQueryFields] Specifies the event fields that are used for search by search-query. If empty or null and search-query is  specified then uses ALL as default Only tournaments having events matching the filter will be returned
         * @param {boolean} [eventHasLineOutcomes] If set to true then tournaments with only Line events without outcomes will be excluded from response. If set to false will do nothing Default is true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsV2(ids, locale, sportIds, countryIds, scheduledFrom, scheduledTo, includeSubsports, tournamentTagIds, tournamentTagFilterOperation, eventLiveliness, eventStatuses, providerIds, sort, pageKey, pageSize, searchQuery, searchQueryFields, eventHasLineOutcomes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTournamentsV2(ids, locale, sportIds, countryIds, scheduledFrom, scheduledTo, includeSubsports, tournamentTagIds, tournamentTagFilterOperation, eventLiveliness, eventStatuses, providerIds, sort, pageKey, pageSize, searchQuery, searchQueryFields, eventHasLineOutcomes, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {string} query
         * @param {string} locale
         * @param {number} [sportId]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments(query, locale, sportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTournaments(query, locale, sportId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TournamentsApi - factory interface
 * @export
 */
export const TournamentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TournamentsApiFp(configuration);
    return {
        /**
         * Retrieves a list of tournaments based on the provided filters. - **Tournaments by ids:**   - Returns all tournaments with specified ids. If this parameter is defined other parameters must be empty  - **All Tournaments by Sport:**     - Returns tournaments for the specified `sport-id`.  - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns tournaments with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns tournaments with at least one of the specified `tag-ids`.  - **Top Tournaments:**   - `top=true`: Returns only top tournaments.   - `top=false` or omit `top`: Returns all tournaments.
         * @summary Returns a list of tournaments.
         * @param {TournamentsApiGetTournamentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getTournaments(requestParameters = {}, options) {
            return localVarFp.getTournaments(requestParameters.ids, requestParameters.locale, requestParameters.sportId, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.includeSubsports, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.eventLiveliness, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of tournaments that has at least one corresponding event that matches all filters
         * @summary Returns a list of tournaments.
         * @param {TournamentsApiGetTournamentsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTournamentsV2(requestParameters = {}, options) {
            return localVarFp.getTournamentsV2(requestParameters.ids, requestParameters.locale, requestParameters.sportIds, requestParameters.countryIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.includeSubsports, requestParameters.tournamentTagIds, requestParameters.tournamentTagFilterOperation, requestParameters.eventLiveliness, requestParameters.eventStatuses, requestParameters.providerIds, requestParameters.sort, requestParameters.pageKey, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.eventHasLineOutcomes, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return a list of tournaments searched by query
         * @param {TournamentsApiSearchTournamentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        searchTournaments(requestParameters, options) {
            return localVarFp.searchTournaments(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TournamentsApi - object-oriented interface
 * @export
 * @class TournamentsApi
 * @extends {BaseAPI}
 */
export class TournamentsApi extends BaseAPI {
    /**
     * Retrieves a list of tournaments based on the provided filters. - **Tournaments by ids:**   - Returns all tournaments with specified ids. If this parameter is defined other parameters must be empty  - **All Tournaments by Sport:**     - Returns tournaments for the specified `sport-id`.  - Do not use `top` and `tag-ids` together. If both are included, a 400 error will be returned. - **Tags Matching:**   - If you use `tag-ids`, you must also include `tag-filter-operation`, otherwise a 400 error will be returned.   - **STRICT Matching:** Returns tournaments with exactly the specified `tag-ids`, excluding any with additional tags.   - **LOOSE Matching:** Returns tournaments with at least one of the specified `tag-ids`.  - **Top Tournaments:**   - `top=true`: Returns only top tournaments.   - `top=false` or omit `top`: Returns all tournaments.
     * @summary Returns a list of tournaments.
     * @param {TournamentsApiGetTournamentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    getTournaments(requestParameters = {}, options) {
        return TournamentsApiFp(this.configuration).getTournaments(requestParameters.ids, requestParameters.locale, requestParameters.sportId, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.top, requestParameters.includeSubsports, requestParameters.tagIds, requestParameters.tagFilterOperation, requestParameters.eventLiveliness, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of tournaments that has at least one corresponding event that matches all filters
     * @summary Returns a list of tournaments.
     * @param {TournamentsApiGetTournamentsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    getTournamentsV2(requestParameters = {}, options) {
        return TournamentsApiFp(this.configuration).getTournamentsV2(requestParameters.ids, requestParameters.locale, requestParameters.sportIds, requestParameters.countryIds, requestParameters.scheduledFrom, requestParameters.scheduledTo, requestParameters.includeSubsports, requestParameters.tournamentTagIds, requestParameters.tournamentTagFilterOperation, requestParameters.eventLiveliness, requestParameters.eventStatuses, requestParameters.providerIds, requestParameters.sort, requestParameters.pageKey, requestParameters.pageSize, requestParameters.searchQuery, requestParameters.searchQueryFields, requestParameters.eventHasLineOutcomes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return a list of tournaments searched by query
     * @param {TournamentsApiSearchTournamentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TournamentsApi
     */
    searchTournaments(requestParameters, options) {
        return TournamentsApiFp(this.configuration).searchTournaments(requestParameters.query, requestParameters.locale, requestParameters.sportId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VerificationsApi - axios parameter creator
 * @export
 */
export const VerificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create verification request for further signature
         * @param {NewVerification} [newVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationRequest: (newVerification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newVerification, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VerificationsApi - functional programming interface
 * @export
 */
export const VerificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = VerificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create verification request for further signature
         * @param {NewVerification} [newVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationRequest(newVerification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVerificationRequest(newVerification, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VerificationsApi - factory interface
 * @export
 */
export const VerificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VerificationsApiFp(configuration);
    return {
        /**
         *
         * @summary Create verification request for further signature
         * @param {VerificationsApiCreateVerificationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVerificationRequest(requestParameters = {}, options) {
            return localVarFp.createVerificationRequest(requestParameters.newVerification, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VerificationsApi - object-oriented interface
 * @export
 * @class VerificationsApi
 * @extends {BaseAPI}
 */
export class VerificationsApi extends BaseAPI {
    /**
     *
     * @summary Create verification request for further signature
     * @param {VerificationsApiCreateVerificationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationsApi
     */
    createVerificationRequest(requestParameters = {}, options) {
        return VerificationsApiFp(this.configuration).createVerificationRequest(requestParameters.newVerification, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VirtualCategoriesApi - axios parameter creator
 * @export
 */
export const VirtualCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Return a list of virtual categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories: (locale, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/virtual-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VirtualCategoriesApi - functional programming interface
 * @export
 */
export const VirtualCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = VirtualCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Return a list of virtual categories
         * @param {string} [locale]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories(locale, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVirtualCategories(locale, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VirtualCategoriesApi - factory interface
 * @export
 */
export const VirtualCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VirtualCategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary Return a list of virtual categories
         * @param {VirtualCategoriesApiGetVirtualCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories(requestParameters = {}, options) {
            return localVarFp.getVirtualCategories(requestParameters.locale, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VirtualCategoriesApi - object-oriented interface
 * @export
 * @class VirtualCategoriesApi
 * @extends {BaseAPI}
 */
export class VirtualCategoriesApi extends BaseAPI {
    /**
     *
     * @summary Return a list of virtual categories
     * @param {VirtualCategoriesApiGetVirtualCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualCategoriesApi
     */
    getVirtualCategories(requestParameters = {}, options) {
        return VirtualCategoriesApiFp(this.configuration).getVirtualCategories(requestParameters.locale, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * VirtualGamesApi - axios parameter creator
 * @export
 */
export const VirtualGamesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create BetGames token.
         * @param {NewVirtualGamesToken} [newVirtualGamesToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBetGamesToken: (newVirtualGamesToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/virtual-games/betgames/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newVirtualGamesToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Virtual Games token.
         * @param {NewVirtualGamesToken} [newVirtualGamesToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVirtualGamesToken: (newVirtualGamesToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/virtual-game-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newVirtualGamesToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * VirtualGamesApi - functional programming interface
 * @export
 */
export const VirtualGamesApiFp = function (configuration) {
    const localVarAxiosParamCreator = VirtualGamesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create BetGames token.
         * @param {NewVirtualGamesToken} [newVirtualGamesToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBetGamesToken(newVirtualGamesToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBetGamesToken(newVirtualGamesToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Virtual Games token.
         * @param {NewVirtualGamesToken} [newVirtualGamesToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVirtualGamesToken(newVirtualGamesToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVirtualGamesToken(newVirtualGamesToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * VirtualGamesApi - factory interface
 * @export
 */
export const VirtualGamesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = VirtualGamesApiFp(configuration);
    return {
        /**
         *
         * @summary Create BetGames token.
         * @param {VirtualGamesApiCreateBetGamesTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBetGamesToken(requestParameters = {}, options) {
            return localVarFp.createBetGamesToken(requestParameters.newVirtualGamesToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Virtual Games token.
         * @param {VirtualGamesApiCreateVirtualGamesTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVirtualGamesToken(requestParameters = {}, options) {
            return localVarFp.createVirtualGamesToken(requestParameters.newVirtualGamesToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * VirtualGamesApi - object-oriented interface
 * @export
 * @class VirtualGamesApi
 * @extends {BaseAPI}
 */
export class VirtualGamesApi extends BaseAPI {
    /**
     *
     * @summary Create BetGames token.
     * @param {VirtualGamesApiCreateBetGamesTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualGamesApi
     */
    createBetGamesToken(requestParameters = {}, options) {
        return VirtualGamesApiFp(this.configuration).createBetGamesToken(requestParameters.newVirtualGamesToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Virtual Games token.
     * @param {VirtualGamesApiCreateVirtualGamesTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VirtualGamesApi
     */
    createVirtualGamesToken(requestParameters = {}, options) {
        return VirtualGamesApiFp(this.configuration).createVirtualGamesToken(requestParameters.newVirtualGamesToken, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * WithdrawalsApi - axios parameter creator
 * @export
 */
export const WithdrawalsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a withdrawal transaction.
         * @param {string} [verificationId] Verification id is optional for some regions, backend must check via feature flag
         * @param {string} [verificationCode] Verification code is optional for some regions, backend must check via feature flag
         * @param {string} [locale] Needed for localization of constraint reasons
         * @param {NewWithdrawal} [newWithdrawal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawalTransaction: (verificationId, verificationCode, locale, newWithdrawal, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (verificationId != null) {
                localVarHeaderParameter['verification-id'] = String(verificationId);
            }
            if (verificationCode != null) {
                localVarHeaderParameter['verification-code'] = String(verificationCode);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newWithdrawal, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of withdrawal fees.
         * @param {string} accountId
         * @param {number} providerId
         * @param {Array<number>} methodIds
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalFees: (accountId, providerId, methodIds, amount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getWithdrawalFees', 'accountId', accountId);
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getWithdrawalFees', 'providerId', providerId);
            // verify required parameter 'methodIds' is not null or undefined
            assertParamExists('getWithdrawalFees', 'methodIds', methodIds);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getWithdrawalFees', 'amount', amount);
            const localVarPath = `/withdrawals/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider-id'] = providerId;
            }
            if (methodIds) {
                localVarQueryParameter['method-ids'] = methodIds;
            }
            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of withdrawal methods.
         * @param {string} [locale]
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalMethods: (locale, accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/withdrawals/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns withdrawal tax.
         * @param {string} accountId
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalTax: (accountId, amount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getWithdrawalTax', 'accountId', accountId);
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('getWithdrawalTax', 'amount', amount);
            const localVarPath = `/withdrawals/tax`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns a list of withdrawals for a current client.
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [accountId]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [currencyId]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<PaymentStatus>} [statuses]
         * @param {ApproveStatus} [approve]
         * @param {number} [methodId]
         * @param {number} [providerId]
         * @param {Array<string>} [ids] List of ids
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawals: (offset, limit, accountId, from, to, currencyId, minAmount, maxAmount, statuses, approve, methodId, providerId, ids, order, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (accountId !== undefined) {
                localVarQueryParameter['account-id'] = accountId;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (currencyId !== undefined) {
                localVarQueryParameter['currency-id'] = currencyId;
            }
            if (minAmount !== undefined) {
                localVarQueryParameter['min-amount'] = minAmount;
            }
            if (maxAmount !== undefined) {
                localVarQueryParameter['max-amount'] = maxAmount;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (approve !== undefined) {
                localVarQueryParameter['approve'] = approve;
            }
            if (methodId !== undefined) {
                localVarQueryParameter['method-id'] = methodId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider-id'] = providerId;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WithdrawalsApi - functional programming interface
 * @export
 */
export const WithdrawalsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WithdrawalsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a withdrawal transaction.
         * @param {string} [verificationId] Verification id is optional for some regions, backend must check via feature flag
         * @param {string} [verificationCode] Verification code is optional for some regions, backend must check via feature flag
         * @param {string} [locale] Needed for localization of constraint reasons
         * @param {NewWithdrawal} [newWithdrawal]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawalTransaction(verificationId, verificationCode, locale, newWithdrawal, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWithdrawalTransaction(verificationId, verificationCode, locale, newWithdrawal, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of withdrawal fees.
         * @param {string} accountId
         * @param {number} providerId
         * @param {Array<number>} methodIds
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalFees(accountId, providerId, methodIds, amount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWithdrawalFees(accountId, providerId, methodIds, amount, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of withdrawal methods.
         * @param {string} [locale]
         * @param {string} [accountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalMethods(locale, accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWithdrawalMethods(locale, accountId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns withdrawal tax.
         * @param {string} accountId
         * @param {number} amount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalTax(accountId, amount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWithdrawalTax(accountId, amount, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns a list of withdrawals for a current client.
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [accountId]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [currencyId]
         * @param {number} [minAmount]
         * @param {number} [maxAmount]
         * @param {Array<PaymentStatus>} [statuses]
         * @param {ApproveStatus} [approve]
         * @param {number} [methodId]
         * @param {number} [providerId]
         * @param {Array<string>} [ids] List of ids
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawals(offset, limit, accountId, from, to, currencyId, minAmount, maxAmount, statuses, approve, methodId, providerId, ids, order, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWithdrawals(offset, limit, accountId, from, to, currencyId, minAmount, maxAmount, statuses, approve, methodId, providerId, ids, order, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WithdrawalsApi - factory interface
 * @export
 */
export const WithdrawalsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WithdrawalsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a withdrawal transaction.
         * @param {WithdrawalsApiCreateWithdrawalTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawalTransaction(requestParameters = {}, options) {
            return localVarFp.createWithdrawalTransaction(requestParameters.verificationId, requestParameters.verificationCode, requestParameters.locale, requestParameters.newWithdrawal, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of withdrawal fees.
         * @param {WithdrawalsApiGetWithdrawalFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalFees(requestParameters, options) {
            return localVarFp.getWithdrawalFees(requestParameters.accountId, requestParameters.providerId, requestParameters.methodIds, requestParameters.amount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of withdrawal methods.
         * @param {WithdrawalsApiGetWithdrawalMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalMethods(requestParameters = {}, options) {
            return localVarFp.getWithdrawalMethods(requestParameters.locale, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns withdrawal tax.
         * @param {WithdrawalsApiGetWithdrawalTaxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawalTax(requestParameters, options) {
            return localVarFp.getWithdrawalTax(requestParameters.accountId, requestParameters.amount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns a list of withdrawals for a current client.
         * @param {WithdrawalsApiGetWithdrawalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithdrawals(requestParameters = {}, options) {
            return localVarFp.getWithdrawals(requestParameters.offset, requestParameters.limit, requestParameters.accountId, requestParameters.from, requestParameters.to, requestParameters.currencyId, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.statuses, requestParameters.approve, requestParameters.methodId, requestParameters.providerId, requestParameters.ids, requestParameters.order, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WithdrawalsApi - object-oriented interface
 * @export
 * @class WithdrawalsApi
 * @extends {BaseAPI}
 */
export class WithdrawalsApi extends BaseAPI {
    /**
     *
     * @summary Create a withdrawal transaction.
     * @param {WithdrawalsApiCreateWithdrawalTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    createWithdrawalTransaction(requestParameters = {}, options) {
        return WithdrawalsApiFp(this.configuration).createWithdrawalTransaction(requestParameters.verificationId, requestParameters.verificationCode, requestParameters.locale, requestParameters.newWithdrawal, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of withdrawal fees.
     * @param {WithdrawalsApiGetWithdrawalFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    getWithdrawalFees(requestParameters, options) {
        return WithdrawalsApiFp(this.configuration).getWithdrawalFees(requestParameters.accountId, requestParameters.providerId, requestParameters.methodIds, requestParameters.amount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of withdrawal methods.
     * @param {WithdrawalsApiGetWithdrawalMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    getWithdrawalMethods(requestParameters = {}, options) {
        return WithdrawalsApiFp(this.configuration).getWithdrawalMethods(requestParameters.locale, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns withdrawal tax.
     * @param {WithdrawalsApiGetWithdrawalTaxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    getWithdrawalTax(requestParameters, options) {
        return WithdrawalsApiFp(this.configuration).getWithdrawalTax(requestParameters.accountId, requestParameters.amount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns a list of withdrawals for a current client.
     * @param {WithdrawalsApiGetWithdrawalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawalsApi
     */
    getWithdrawals(requestParameters = {}, options) {
        return WithdrawalsApiFp(this.configuration).getWithdrawals(requestParameters.offset, requestParameters.limit, requestParameters.accountId, requestParameters.from, requestParameters.to, requestParameters.currencyId, requestParameters.minAmount, requestParameters.maxAmount, requestParameters.statuses, requestParameters.approve, requestParameters.methodId, requestParameters.providerId, requestParameters.ids, requestParameters.order, options).then((request) => request(this.axios, this.basePath));
    }
}
